var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2, _circle3, _circle4, _circle5, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g, _g2, _g3, _g4, _g5, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFishResult4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 714.67 350",
    style: {
      enableBackground: "new 0 0 714.67 350"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{opacity:0.1;fill:#FFC687;}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{fill:url(#SVGID_4_);}\n\t.st5{fill:url(#SVGID_5_);}\n\t.st6{fill:url(#SVGID_6_);}\n\t.st7{opacity:0.2;fill:url(#SVGID_7_);}\n\t.st8{fill:#FFFFFF;}\n\t.st9{fill:url(#SVGID_8_);}\n\t.st10{fill:#110700;}\n\t.st11{fill:#DC9263;}\n\t.st12{fill:url(#SVGID_9_);}\n\t.st13{fill:url(#SVGID_10_);}\n\t.st14{fill:url(#SVGID_11_);}\n\t.st15{fill:#FFC687;}\n\t.st16{fill:url(#SVGID_12_);}\n\t.st17{fill:url(#SVGID_13_);}\n\t.st18{fill:url(#SVGID_14_);}\n\t.st19{opacity:0.4;fill:#605D66;}\n\t.st20{fill:url(#SVGID_15_);}\n\t.st21{fill:url(#SVGID_16_);}\n\t.st22{fill:url(#SVGID_17_);}\n\t.st23{opacity:0.07;fill:#FFC687;}\n\t.st24{opacity:0.1;fill:#FFFFFF;}\n\t.st25{opacity:0.05;fill:#FFFFFF;}\n\t.st26{opacity:0.3;fill:url(#SVGID_18_);}\n\t.st27{fill:url(#SVGID_19_);}\n\t.st28{fill:url(#SVGID_20_);}\n\t.st29{fill:url(#SVGID_21_);}\n\t.st30{fill:url(#SVGID_22_);}\n\t.st31{fill:url(#SVGID_23_);}\n\t.st32{fill:url(#SVGID_24_);}\n\t.st33{fill:url(#SVGID_25_);}\n\t.st34{fill:url(#SVGID_26_);}\n\t.st35{fill:url(#SVGID_27_);}\n\t.st36{fill:url(#SVGID_28_);}\n\t.st37{fill:url(#SVGID_29_);}\n\t.st38{fill:url(#SVGID_30_);}\n\t.st39{fill:url(#SVGID_31_);}\n\t.st40{fill:url(#SVGID_32_);}\n\t.st41{fill:url(#SVGID_33_);}\n\t.st42{fill:url(#SVGID_34_);}\n\t.st43{fill:url(#SVGID_35_);}\n\t.st44{fill:url(#SVGID_36_);}\n\t.st45{fill:url(#SVGID_37_);}\n\t.st46{fill:url(#SVGID_38_);}\n\t.st47{fill:url(#SVGID_39_);}\n\t.st48{fill:url(#SVGID_40_);}\n\t.st49{fill:url(#SVGID_41_);}\n\t.st50{fill:url(#SVGID_42_);}\n\t.st51{fill:url(#SVGID_43_);}\n\t.st52{fill:url(#SVGID_44_);}\n\t.st53{fill:url(#SVGID_45_);}\n\t.st54{fill:url(#SVGID_46_);}\n\t.st55{fill:url(#SVGID_47_);}\n\t.st56{fill:url(#SVGID_48_);}\n\t.st57{fill:url(#SVGID_49_);}\n\t.st58{fill:url(#SVGID_50_);}\n\t.st59{fill:url(#SVGID_51_);}\n\t.st60{fill:url(#SVGID_52_);}\n\t.st61{fill:url(#SVGID_53_);}\n\t.st62{fill:url(#SVGID_54_);}\n\t.st63{fill:url(#SVGID_55_);}\n\t.st64{fill:url(#SVGID_56_);}\n\t.st65{fill:url(#SVGID_57_);}\n\t.st66{fill:url(#SVGID_58_);}\n\t.st67{fill:url(#SVGID_59_);}\n\t.st68{fill:url(#SVGID_60_);}\n\t.st69{fill:url(#SVGID_61_);}\n\t.st70{fill:url(#SVGID_62_);}\n\t.st71{fill:url(#SVGID_63_);}\n\t.st72{fill:url(#SVGID_64_);}\n\t.st73{fill:url(#SVGID_65_);}\n\t.st74{fill:url(#SVGID_66_);}\n\t.st75{fill:url(#SVGID_67_);}\n\t.st76{fill:url(#SVGID_68_);}\n\t.st77{fill:url(#SVGID_69_);}\n\t.st78{fill:url(#SVGID_70_);}\n\t.st79{fill:url(#SVGID_71_);}\n\t.st80{fill:url(#SVGID_72_);}\n\t.st81{fill:url(#SVGID_73_);}\n\t.st82{fill:url(#SVGID_74_);}\n\t.st83{fill:url(#SVGID_75_);}\n\t.st84{fill:url(#SVGID_76_);}\n\t.st85{fill:url(#SVGID_77_);}\n\t.st86{fill:url(#SVGID_78_);}\n\t.st87{fill:url(#SVGID_79_);}\n\t.st88{fill:url(#SVGID_80_);}\n\t.st89{fill:url(#SVGID_81_);}\n\t.st90{fill:url(#SVGID_82_);}\n\t.st91{fill:url(#SVGID_83_);}\n\t.st92{fill:url(#SVGID_84_);}\n\t.st93{fill:url(#SVGID_85_);}\n\t.st94{fill:url(#SVGID_86_);}\n\t.st95{fill:url(#SVGID_87_);}\n\t.st96{fill:url(#SVGID_88_);}\n\t.st97{fill:url(#SVGID_89_);}\n\t.st98{fill:url(#SVGID_90_);}\n\t.st99{fill:url(#SVGID_91_);}\n\t.st100{fill:url(#SVGID_92_);}\n\t.st101{fill:url(#SVGID_93_);}\n\t.st102{fill:url(#SVGID_94_);}\n\t.st103{fill:url(#SVGID_95_);}\n\t.st104{fill:url(#SVGID_96_);}\n\t.st105{fill:url(#SVGID_97_);}\n\t.st106{fill:url(#SVGID_98_);}\n\t.st107{fill:url(#SVGID_99_);}\n\t.st108{fill:url(#SVGID_100_);}\n\t.st109{fill:url(#SVGID_101_);}\n\t.st110{fill:url(#SVGID_102_);}\n\t.st111{fill:url(#SVGID_103_);}\n\t.st112{fill:url(#SVGID_104_);}\n\t.st113{fill:url(#SVGID_105_);}\n\t.st114{fill:url(#SVGID_106_);}\n\t.st115{fill:url(#SVGID_107_);}\n\t.st116{fill:url(#SVGID_108_);}\n\t.st117{fill:url(#SVGID_109_);}\n\t.st118{fill:url(#SVGID_110_);}\n\t.st119{fill:url(#SVGID_111_);}\n\t.st120{fill:url(#SVGID_112_);}\n\t.st121{fill:url(#SVGID_113_);}\n\t.st122{fill:url(#SVGID_114_);}\n\t.st123{fill:url(#SVGID_115_);}\n\t.st124{fill:url(#SVGID_116_);}\n\t.st125{fill:url(#SVGID_117_);}\n\t.st126{fill:url(#SVGID_118_);}\n\t.st127{fill:url(#SVGID_119_);}\n\t.st128{fill:url(#SVGID_120_);}\n\t.st129{fill:url(#SVGID_121_);}\n\t.st130{fill:url(#SVGID_122_);}\n\t.st131{fill:url(#SVGID_123_);}\n\t.st132{fill:url(#SVGID_124_);}\n\t.st133{fill:url(#SVGID_125_);}\n\t.st134{fill:url(#SVGID_126_);}\n\t.st135{fill:url(#SVGID_127_);}\n\t.st136{fill:url(#SVGID_128_);}\n\t.st137{fill:url(#SVGID_129_);}\n\t.st138{fill:url(#SVGID_130_);}\n\t.st139{fill:url(#SVGID_131_);}\n\t.st140{fill:url(#SVGID_132_);}\n\t.st141{fill:url(#SVGID_133_);}\n\t.st142{fill:url(#SVGID_134_);}\n\t.st143{fill:url(#SVGID_135_);}\n\t.st144{fill:url(#SVGID_136_);}\n\t.st145{fill:url(#SVGID_137_);}\n\t.st146{fill:url(#SVGID_138_);}\n\t.st147{opacity:0.03;fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 360.8631,
    y1: 277.9182,
    x2: 347.0991,
    y2: 70.3114
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DC9263"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8A3813"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M712.83,212.99c-3.21-7.15-21.48,23.48-22.59,25.34c0.6-1.33,7.91-17.38,11.77-28.08 c1.49-4.16,2.47-7.51,2.33-8.89c-0.33-3.49-2.93-8.33-6.78-13.71c-2.85-4.02-6.39-8.34-10.17-12.65 c-3.78-4.31-7.82-8.59-11.66-12.54c-2.79-2.87-5.49-5.55-7.91-7.94c-2.43-2.37-4.59-4.45-6.33-6.08c-2.78-2.62-5.38-5.38-7.86-8.26 c-4.37-5.12-12.61-14.34-23.57-24.75c-2.98-2.82-6.17-5.75-9.54-8.7c-12.36-10.85-27.14-22.1-43.22-30.84 c-2.31-1.26-4.65-2.47-7.01-3.61c-29.14-14.1-54.55-25.59-78.96-33.39l-0.02-0.03c0,0-0.02,0-0.03-0.02 c-0.03-0.03-0.11-0.08-0.23-0.16c-0.11-0.08-0.26-0.17-0.45-0.29c-0.11-0.06-0.22-0.14-0.34-0.22c-0.22-0.14-0.47-0.28-0.74-0.47 c-0.48-0.29-1.07-0.64-1.75-1.04c-0.6-0.36-1.3-0.74-2.06-1.16c-1.35-0.74-2.93-1.6-4.78-2.53c-0.36-0.19-0.74-0.39-1.13-0.57 c-3.47-1.74-7.77-3.74-12.89-5.88c-1.41-0.59-2.87-1.18-4.4-1.8c-0.62-0.25-1.27-0.5-1.92-0.74c-0.65-0.25-1.32-0.51-1.98-0.76 c-0.67-0.26-1.35-0.51-2.05-0.76c-0.68-0.26-1.4-0.51-2.11-0.78c-1.43-0.51-2.9-1.04-4.4-1.55c-0.76-0.26-1.54-0.51-2.31-0.78 c-1.55-0.53-3.15-1.04-4.81-1.57c-0.82-0.26-1.64-0.53-2.5-0.78c-1.67-0.53-3.41-1.04-5.19-1.55c-0.88-0.26-1.77-0.53-2.68-0.78 c-0.91-0.26-1.83-0.51-2.78-0.76c-4.65-1.29-9.58-2.53-14.79-3.72c-0.73-0.17-1.46-0.34-2.2-0.51c-6.78-1.52-14.03-2.96-21.74-4.28 c-1.18-0.2-2.37-0.4-3.58-0.59c-7.24-1.18-14.87-2.25-22.9-3.16C227.61-13.94,97.65,85.19,108.88,87.96l0.08,0.02 c0.12,0.03,0.28,0.05,0.45,0.05c0.11,0,0.16,0,0.16,0c14.45-0.45,69.03,29.99,85.63,29.99c0.51,0,0.99-0.03,1.44-0.09 c0.05,0,0.08-0.02,0.12-0.02c-16.19,13.09-36.86,6.56-36.86,6.56s-0.02,0-0.03-0.02c-0.03-0.03-0.06-0.05-0.11-0.08 c-0.06-0.03-0.11-0.08-0.19-0.12c-0.5-0.31-1.55-1.01-3.02-1.97c-0.42-0.28-0.87-0.57-1.36-0.88c-0.11-0.06-0.23-0.14-0.34-0.22 c-0.22-0.12-0.42-0.26-0.64-0.42c-10.5-6.79-32.61-21.14-41.7-27.03c-2.71-1.75-5.85-2.7-9.07-2.71 c-9.55-0.12-28.27,0.73-41.53,12.05c-0.88,0.74-1.75,1.55-2.57,2.4c-0.42,0.42-0.82,0.85-1.22,1.3 C41.29,125.64,11.07,188.18,3.2,209.97c-0.56,1.55-0.99,2.88-1.32,3.99c-4.84,16.68,1.32,25.03,0,32.05 c-1.32,7.02,0.43,16.25,10.98,19.34c10.54,3.07,49.2,49.19,84.77,43.48c0.7-0.11,1.4-0.23,2.06-0.39c0.33-0.05,0.62-0.11,0.93-0.19 c0.74-0.16,1.49-0.34,2.22-0.53c0.06-0.02,0.14-0.03,0.22-0.06c0.74-0.2,1.49-0.42,2.2-0.64c0.08-0.03,0.16-0.05,0.23-0.08 c0.79-0.25,1.55-0.53,2.29-0.81c0.68-0.25,1.33-0.51,1.98-0.79c0.19-0.08,0.36-0.16,0.54-0.25c0.68-0.28,1.33-0.59,1.98-0.91 c0.73-0.36,1.43-0.73,2.12-1.12c0.7-0.37,1.36-0.78,2.03-1.19c0.56-0.34,1.1-0.68,1.63-1.04c0.12-0.08,0.23-0.16,0.34-0.23 c0.51-0.37,1.35-0.96,1.86-1.33c0.19-0.14,0.37-0.28,0.56-0.43c0.39-0.28,0.76-0.57,1.13-0.87c0.71-0.59,1.41-1.18,2.09-1.78 c0.48-0.42,0.95-0.85,1.4-1.29c0.53-0.5,1.05-1.01,1.55-1.52c0.02-0.02,0.05-0.03,0.06-0.06c0.5-0.51,0.99-1.02,1.46-1.54 c4.06-4.39,7.44-9.15,10.44-13.8c0.45-0.7,0.88-1.38,1.3-2.06c2.02-3.23,3.86-6.36,5.63-9.2c0.29-0.5,0.6-0.98,0.9-1.46l0.02-0.02 c0.29-0.48,0.6-0.95,0.9-1.41c2.06-3.18,4.06-5.86,6.14-7.72c6.81-6.09,15.69-9.35,26.83-9.64c6.64-0.19,14.1,0.68,22.36,2.62 c0,0-7.07,1.88-15.6,4.56c-10.47,3.29-23.14,7.78-27.52,11.47c-17.18,14.45-21.43,33.8-22.13,43.08c-0.08,1.05-0.11,1.97-0.11,2.74 c0,7.57,15.74,27.76,60.23,30.84c0,0,65.5,18.48,116.25,0c50.75-18.48,51.78-20.87,62.4-20.87c0.5,0,1.02,0.02,1.55,0.03 c0.14,0,0.28,0.02,0.42,0.02v0.02c-0.02,0.28-0.03,0.56-0.05,0.82c0,0.05,0,0.09-0.02,0.12c-0.03,0.26-0.06,0.54-0.11,0.81 c-0.05,0.29-0.11,0.57-0.19,0.87c-0.06,0.26-0.14,0.54-0.23,0.81c-0.12,0.39-0.28,0.78-0.47,1.15c-0.08,0.2-0.19,0.4-0.29,0.6 c-0.14,0.25-0.29,0.51-0.45,0.78c-0.16,0.25-0.33,0.48-0.5,0.71c-0.16,0.19-0.31,0.39-0.48,0.59c-0.28,0.34-0.59,0.67-0.93,0.99 c-0.25,0.25-0.51,0.5-0.81,0.73c-0.33,0.26-0.65,0.53-1.01,0.79c-0.34,0.25-0.7,0.5-1.07,0.73c-0.39,0.25-0.78,0.48-1.19,0.7 c-0.82,0.47-1.72,0.9-2.71,1.32c-12.54,5.33-3.18,6.7,10.03,3.5c0.79-0.2,1.61-0.4,2.43-0.64c1.32-0.37,2.67-0.78,4.02-1.23 c0.9-0.29,1.81-0.62,2.71-0.96c0.31-0.11,0.6-0.23,0.91-0.34c0.6-0.23,1.19-0.48,1.8-0.73c0.43-0.19,0.87-0.37,1.3-0.57 c0.91-0.39,1.8-0.81,2.68-1.26c0.43-0.23,0.87-0.45,1.3-0.68c1.29-0.68,2.54-1.41,3.74-2.19c0.34-0.23,0.7-0.45,1.02-0.68 c1.09-0.74,2.11-1.52,3.09-2.34c0.25-0.22,0.5-0.42,0.74-0.65c0.22-0.19,0.43-0.39,0.64-0.59c0.02,0,0.02,0,0.02,0 c0.23,0.03,0.47,0.05,0.7,0.08c0.19,0.02,0.37,0.03,0.54,0.05c0.78,0.06,1.57,0.14,2.37,0.22c0.28,0.03,0.56,0.05,0.84,0.06 c1.55,0.12,3.16,0.23,4.84,0.34c0.05,0.02,0.11,0.02,0.16,0.02c6.68,0.39,14.31,0.54,23.09,0.23c0,0,6.76-0.67,15.49-1.52 c6.98-0.68,15.21-1.49,22.22-2.17c7.02-0.68,12.82-1.24,14.96-1.43c51.16,2.48,97.94-9.35,97.94-9.35c1.91,0.2,3.8,0.28,5.64,0.28 c10.56,0,19.82-2.78,23.4-3.8c2.33-0.67,9.86-3.72,19.82-8.67c11.96-5.94,27.42-14.62,41.49-25.14 c14.1-10.51,26.81-22.89,33.31-36.21C713.56,232.43,716.72,221.7,712.83,212.99z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M702.01,210.25c-28.32,9.51-161.75,130.22-317.25,79.45c-276.13-90.13-305.1-46.96-381.55-79.74 c1.48-4.12,3.77-9.71,6.63-16.18c0.67-1.54,1.37-3.13,2.12-4.77c0.16-0.33,0.32-0.69,0.48-1.04c0.3-0.67,0.62-1.33,0.92-2.02 c0.07-0.12,0.11-0.26,0.18-0.38c1.29-2.86,2.69-5.83,4.15-8.85c0.92-1.94,1.87-3.9,2.83-5.9c0.77-1.57,1.54-3.13,2.31-4.69 c0.91-1.8,1.8-3.62,2.72-5.42c1.24-2.43,2.49-4.88,3.75-7.3c1.35-2.58,2.69-5.16,4.07-7.69c0.93-1.73,1.88-3.46,2.83-5.17 c0.07-0.14,0.15-0.3,0.25-0.44c1.02-1.84,2.05-3.66,3.05-5.43c0.34-0.6,0.69-1.18,1.02-1.76c0.34-0.59,0.67-1.17,1.02-1.75 c0.34-0.56,0.66-1.14,1-1.7c0.96-1.62,1.91-3.2,2.86-4.73c0.29-0.48,0.58-0.96,0.88-1.42c1.37-2.21,2.72-4.3,4.04-6.24 c0.32-0.47,0.62-0.91,0.92-1.35c0.69-1.02,1.37-1.98,2.06-2.93c0.82-1.1,1.59-2.14,2.35-3.11c0.27-0.36,0.56-0.69,0.84-1.03 c0-0.01,0.01-0.03,0.01-0.03c0.29-0.33,0.55-0.65,0.81-0.95c0.22-0.29,0.45-0.54,0.66-0.78c0.05-0.04,0.08-0.08,0.12-0.14 c0.41-0.45,0.81-0.88,1.22-1.31c0.82-0.85,1.69-1.65,2.58-2.39c0.49-0.43,0.99-0.82,1.5-1.21c0.51-0.4,1.03-0.77,1.54-1.14 c11.56-8.14,26.16-9.58,35.43-9.71c0.87-0.01,1.69-0.01,2.45,0h0.6c3.23,0.01,6.37,0.96,9.07,2.72 c9.09,5.88,31.19,20.24,41.7,27.03c0.22,0.15,0.41,0.29,0.63,0.41c0.11,0.08,0.23,0.15,0.34,0.22c0.49,0.3,0.95,0.6,1.36,0.88 c1.47,0.96,2.53,1.66,3.02,1.97c0.08,0.06,0.14,0.1,0.19,0.12c0.04,0.04,0.08,0.07,0.11,0.08c0.01,0.01,0.03,0.01,0.03,0.01 s4.66,1.47,11.31,1.61c7.33,0.16,17.05-1.29,25.54-8.17c-0.06,0-0.08,0.01-0.12,0.01c-0.45,0.07-0.93,0.1-1.44,0.1 c-4.11,0-10.56-1.88-18.15-4.67c-1.64-0.62-3.33-1.25-5.07-1.95c-22.62-8.91-52.31-23.67-62.4-23.36c0,0-0.06,0-0.17,0 c-0.16,0-0.32-0.03-0.44-0.05l-0.08-0.01c-11.23-2.78,118.73-101.9,255.69-86.3c8.03,0.92,15.66,1.99,22.9,3.16 c1.21,0.19,2.39,0.4,3.57,0.59c7.71,1.32,14.97,2.76,21.74,4.29c0.76,0.17,1.48,0.33,2.21,0.51c5.21,1.2,10.13,2.43,14.79,3.73 c0.93,0.25,1.86,0.49,2.78,0.76c0.91,0.25,1.79,0.51,2.68,0.77c1.77,0.51,3.52,1.03,5.18,1.55c0.87,0.25,1.68,0.51,2.5,0.77 c1.66,0.54,3.26,1.04,4.81,1.57l2.31,0.78c1.5,0.51,2.97,1.03,4.4,1.54c0.71,0.27,1.43,0.52,2.1,0.78c0.03,0.01,0.07,0.03,0.1,0.03 c0.67,0.25,1.32,0.48,1.95,0.73c0.67,0.25,1.33,0.51,1.99,0.76c0.65,0.25,1.29,0.51,1.92,0.76c1.53,0.62,2.98,1.21,4.4,1.79 c5.11,2.14,9.42,4.15,12.88,5.88c0.38,0.18,0.78,0.38,1.13,0.58c1.86,0.92,3.44,1.77,4.78,2.52c0.76,0.43,1.46,0.81,2.06,1.17 c0.69,0.4,1.26,0.74,1.75,1.04c0.29,0.18,0.54,0.32,0.74,0.45c0.14,0.08,0.23,0.16,0.34,0.22c0.19,0.12,0.34,0.22,0.45,0.3 c0.12,0.07,0.21,0.12,0.23,0.15c0.01,0.01,0.03,0.01,0.03,0.01l0.01,0.03c23.08,7.38,47.06,18.05,74.23,31.11 c1.57,0.76,3.15,1.51,4.73,2.28c2.36,1.14,4.7,2.35,7.01,3.6c16.09,8.76,30.86,19.99,43.22,30.85c3.35,2.94,6.56,5.87,9.53,8.7 c10.97,10.39,19.21,19.62,23.58,24.75c2.47,2.87,5.09,5.64,7.86,8.26c1.73,1.62,3.89,3.7,6.32,6.08c2.42,2.39,5.11,5.07,7.91,7.93 c3.85,3.96,7.88,8.24,11.66,12.55c3.78,4.3,7.31,8.63,10.17,12.65c3.85,5.39,6.45,10.21,6.78,13.71 C704.47,202.75,703.5,206.09,702.01,210.25z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 538.6741,
    y1: 319.7059,
    x2: 538.264,
    y2: 243.0038
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M587.62,310.66c0,0-46.78,11.83-97.94,9.35c3.15-0.26,8.34-5.71,13.4-13.18c6.11-9.04,12-21.07,13.66-30.47 c0.65-3.67,1.58-6.93,2.65-9.86c8.44,4.67,20.22,8.13,35.32,5.64c-0.76,8.06,0.4,17.04,7.82,26.83 c10.02,13.21,24.84,11.66,24.84,11.66c0.06,0,0.12,0.02,0.17,0.02C587.57,310.66,587.6,310.66,587.62,310.66z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 538.7278,
    y1: 122.8416,
    x2: 629.739,
    y2: 241.2198
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M711.28,237.13c-18.39,37.74-86.7,67.75-94.62,70.01c-4.25,1.21-16.41,4.87-29.29,3.49 c-5.89-0.64-11.94-2.31-17.46-5.77c-4.88-3.05-8.36-22.79-4.69-29.08c16.94-29.05,17.82-43.02,17.82-43.02s9.36-83.56-88.34-91.71 c-26.27-2.19-3.37-102.2-3.37-102.2c24.41,7.8,49.84,19.32,78.97,33.42c2.36,1.15,4.7,2.34,7.01,3.6c0,0.02,0,0.02,0,0.02 c2.28,1.23,4.53,2.51,6.75,3.85c13.46,8.05,25.86,17.68,36.49,27c5.64,4.96,10.79,9.83,15.3,14.33 c8.09,8.05,14.22,14.95,17.79,19.12c2.48,2.88,5.09,5.64,7.86,8.26c3.46,3.27,8.64,8.28,14.22,14c0.02,0.02,0.02,0.02,0.02,0.02 c12.85,13.18,27.79,30.22,28.61,38.91c0.48,4.95-13.26,35.12-14.1,36.97c1.12-1.86,19.38-32.49,22.59-25.34 C716.72,221.7,713.56,232.43,711.28,237.13z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 558.1156,
    y1: 143.6353,
    x2: 666.6486,
    y2: 294.0311
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8A3813"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M711.28,237.13c-0.34,0.7-0.7,1.4-1.07,2.08c-0.33,0.62-0.68,1.24-1.04,1.86c-0.11,0.19-0.23,0.39-0.34,0.57 c-0.34,0.56-0.68,1.12-1.04,1.67c0,0.02-0.02,0.02-0.02,0.03c-0.36,0.56-0.73,1.12-1.12,1.67c-1.52,2.23-3.18,4.42-4.98,6.56 c-0.43,0.51-0.87,1.01-1.3,1.5c-0.06,0.08-0.12,0.14-0.19,0.22c-0.25,0.29-0.51,0.57-0.78,0.87c-0.43,0.48-0.87,0.96-1.32,1.44 c-2.28,2.45-4.73,4.85-7.29,7.18c-0.48,0.45-0.96,0.88-1.44,1.3c-27.34,24.25-66.8,41.37-72.71,43.05 c-4.14,1.18-15.72,4.67-28.21,3.6c-0.36-0.03-0.71-0.06-1.09-0.11c0,0-14.83,1.55-24.84-11.66c-14.46-19.09-5.12-35.12-4.12-47.26 c0.78-9.51-4.03-13.55-10.64-19.35c-3.02-2.67-6.45-5.69-9.88-9.78c-10.89-13.01-13.48-19.66-10.14-29.3 c4.4-12.69,24.38-19.37,31.85-25.28c2.29-1.81,4.68-3.89,7.01-6.22c8.16-8.16,18.22-3.27,22.79-8.23c0.98-1.07,1.69-2.59,2.09-4.78 c2.26-12.45,12.27-26.1,29.04-42.04c3.36,2.95,6.54,5.88,9.52,8.7c4.95,4.7,9.35,9.16,13.07,13.1c4.54,4.79,8.11,8.84,10.5,11.65 c2.48,2.88,5.09,5.64,7.86,8.26c3.46,3.27,8.64,8.28,14.22,14c0.02,0.02,0.02,0.02,0.02,0.02c5.29,5.43,10.93,11.51,15.8,17.38 c0.45,0.54,0.88,1.07,1.3,1.6c1.72,2.12,3.32,4.2,4.74,6.22c1.26,1.77,2.37,3.49,3.33,5.1c0.25,0.42,0.48,0.82,0.68,1.21 c0.23,0.42,0.47,0.85,0.67,1.26c0.14,0.26,0.26,0.53,0.39,0.79c0.14,0.31,0.28,0.62,0.4,0.91c0.25,0.54,0.45,1.07,0.62,1.58 c0.05,0.16,0.11,0.31,0.16,0.47c0.08,0.23,0.14,0.45,0.19,0.67c0.08,0.26,0.14,0.53,0.17,0.78c0.08,0.33,0.12,0.64,0.16,0.95 c0.48,4.95-13.26,35.12-14.1,36.97c1.12-1.86,19.38-32.49,22.59-25.34C716.72,221.7,713.56,232.43,711.28,237.13z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.6923,
    y1: 43.5006,
    x2: 234.2037,
    y2: -53.1975
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M491.29,38.84c-11.92-3.81-23.6-6.73-35.34-8.64h-0.02c-2.16-0.36-4.31-0.67-6.47-0.95 c-1.88-0.25-3.77-0.48-5.66-0.67c-4.7-0.48-9.37-0.91-14.03-1.3c-2.12-0.17-4.25-0.34-6.37-0.48c-6.53-0.47-13.13-0.81-19.93-0.95 c-2.17-0.06-4.36-0.09-6.57-0.09c-6.39-0.05-12.99,0.08-19.89,0.43c-2.11,0.11-4.23,0.23-6.4,0.37 c-5.29,0.36-10.76,0.84-16.45,1.46c-2.08,0.22-4.2,0.47-6.36,0.73c-5.49,0.68-11.2,1.49-17.15,2.45c-2.06,0.33-4.16,0.67-6.28,1.04 c-6.68,1.15-13.69,2.47-21.04,3.99c-0.74,0.17-1.5,0.33-2.26,0.48c-1.32,0.28-2.61,0.56-3.86,0.85c-8.58,2-15.8,4.34-21.93,6.9 c-1.67,0.68-3.27,1.4-4.79,2.14c-6.14,2.93-11.03,6.09-14.98,9.3c-1.46,1.18-2.79,2.36-4.02,3.55c-4.99,4.84-8.17,9.61-10.67,13.71 c-1.04,1.71-1.97,3.29-2.85,4.71c-2.48,3.97-4.73,6.67-8.53,7.19c-2.25,0.31-4.36,1.05-6.36,2.14c-1.57,0.84-3.05,1.89-4.48,3.09 c-4.22,3.57-7.86,8.47-11.04,13.32c-1.02,1.57-2,3.12-2.93,4.64c-1.88,3.05-3.58,5.91-5.15,8.2c-0.53,0.78-1.46,1.24-2.73,1.44 c-0.05,0-0.08,0.02-0.12,0.02c-0.45,0.06-0.93,0.09-1.44,0.09c-16.59,0-71.17-30.44-85.63-29.99c0,0-0.05,0-0.16,0 c-0.17,0-0.33-0.02-0.45-0.05l-0.08-0.02c-2.78-0.68,3.1-7.29,15.58-16.58c0.36-0.26,0.71-0.53,1.09-0.79 c5.24-3.86,11.57-8.14,18.86-12.64c0.5-0.31,1.01-0.64,1.54-0.95c6.31-3.86,13.32-7.88,20.93-11.89c0.73-0.39,1.47-0.78,2.22-1.16 c7.21-3.75,14.95-7.51,23.1-11.16c1.07-0.48,2.16-0.95,3.24-1.43c8.06-3.52,16.56-6.92,25.4-10.09c1.55-0.57,3.12-1.13,4.7-1.67 c6.57-2.28,13.34-4.42,20.25-6.4c1.64-0.48,3.3-0.95,4.98-1.38c9.43-2.57,19.15-4.82,29.07-6.64c0,0,0,0,0.02,0 c1.64-0.31,3.27-0.6,4.93-0.88c8.13-1.36,16.37-2.43,24.73-3.15c1.6-0.17,3.21-0.29,4.82-0.39c0,0,0,0,0.02,0 c8.09-0.59,16.27-0.85,24.52-0.71c0.02,0,0.02,0,0.02,0c1.97,0.02,3.92,0.06,5.91,0.16h0.02c6.56,0.23,13.15,0.73,19.75,1.47 c2.62,0.29,5.19,0.62,7.72,0.95h0.02c2.33,0.29,4.61,0.62,6.85,0.95c2.82,0.4,5.6,0.84,8.31,1.27c1.21,0.19,2.4,0.39,3.58,0.59 c5.81,0.99,11.38,2.06,16.67,3.18h0.02c1.72,0.36,3.4,0.73,5.05,1.1c0.57,0.12,1.12,0.26,1.67,0.39c0.17,0.05,0.36,0.08,0.53,0.12 c5.21,1.19,10.14,2.43,14.79,3.72c0.95,0.25,1.86,0.5,2.78,0.76c0.91,0.25,1.8,0.51,2.68,0.78c1.67,0.48,3.32,0.96,4.9,1.46 c0.11,0.03,0.2,0.06,0.29,0.09c0.85,0.25,1.67,0.51,2.5,0.78c1.6,0.51,3.15,1.01,4.65,1.52h0.02c0.05,0.02,0.09,0.03,0.14,0.05 c0.78,0.26,1.55,0.51,2.31,0.78c1.5,0.51,2.98,1.04,4.4,1.55c0.71,0.26,1.43,0.51,2.11,0.78c0.7,0.25,1.38,0.5,2.05,0.76 c0.67,0.25,1.33,0.51,1.98,0.76c0.65,0.25,1.3,0.5,1.92,0.74c1.54,0.6,3.01,1.21,4.4,1.8c5.12,2.14,9.41,4.14,12.89,5.88 c0.39,0.19,0.78,0.39,1.13,0.57c1.85,0.93,3.43,1.78,4.78,2.53c0.76,0.42,1.46,0.81,2.06,1.16c0.68,0.4,1.27,0.74,1.75,1.04 c0.28,0.19,0.53,0.33,0.74,0.47c0.12,0.08,0.23,0.16,0.34,0.22c0.19,0.12,0.34,0.22,0.45,0.29 C491.19,38.76,491.26,38.81,491.29,38.84z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 560.3764,
    y1: 158.4078,
    x2: 670.7853,
    y2: 279.3822
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#867567"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    style: {
      stopColor: "#885439"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8A3813"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M711.28,237.13c-0.34,0.7-0.7,1.4-1.07,2.08c-0.33,0.62-0.68,1.24-1.04,1.86c-0.11,0.19-0.23,0.39-0.34,0.57 c-0.34,0.56-0.68,1.12-1.04,1.67c0,0.02-0.02,0.02-0.02,0.03c-0.36,0.56-0.73,1.12-1.12,1.67c-1.52,2.23-3.18,4.42-4.98,6.56 c-0.43,0.51-0.87,1.01-1.3,1.5c-0.06,0.08-0.12,0.14-0.19,0.22c-0.25,0.29-0.51,0.57-0.78,0.87c-0.43,0.48-0.87,0.96-1.32,1.44 c-2.28,2.45-4.73,4.85-7.29,7.18c-0.48,0.45-0.96,0.88-1.44,1.3c-24.58,21.8-58.95,37.84-69.93,42.07 c-1.24,0.48-2.17,0.81-2.78,0.98c-4.14,1.18-15.72,4.67-28.21,3.6c-0.36-0.03-0.71-0.06-1.09-0.11l-6.17-12.16 c-15.06-31.97-23.57-76.66,3.64-119.82c2.28-3.61,18.1-12.06,22.17,3.26c0.47,1.77-0.29,7.48-0.74,9.92 c-5.51,30.27,29.24,18.04,22.77,9.54c-4.2-5.52-7.24-7.23-4.28-17.57c1.81-6.33-10.58-24.33,2.15-22.26 c7.41,1.2,9.73,5.8,21.88-0.43c12.14-6.22,26.3,1.09,26.9,1.32c0.02,0.02,0.02,0.02,0.02,0.02c5.29,5.43,10.93,11.51,15.8,17.38 c0.45,0.54,0.88,1.07,1.3,1.6c1.72,2.12,3.32,4.2,4.74,6.22c1.26,1.77,2.37,3.49,3.33,5.1c0.23,0.42,0.47,0.81,0.68,1.21 c0.23,0.42,0.47,0.85,0.67,1.26c0.14,0.26,0.26,0.53,0.39,0.79c0.14,0.31,0.28,0.62,0.4,0.91c0.25,0.54,0.45,1.07,0.62,1.58 c0.05,0.16,0.11,0.31,0.16,0.47c0.08,0.23,0.14,0.45,0.19,0.67c0.08,0.26,0.14,0.53,0.17,0.78c0.08,0.33,0.12,0.64,0.16,0.95 c0.47,4.73-12.05,32.47-13.91,36.55c-0.08,0.2-0.16,0.34-0.19,0.42c0.05-0.09,0.14-0.23,0.26-0.43c0.11-0.17,0.23-0.39,0.39-0.64 c0.09-0.16,0.2-0.34,0.33-0.54c0.12-0.19,0.25-0.4,0.39-0.64c0.12-0.2,0.26-0.43,0.4-0.67c0.36-0.57,0.76-1.21,1.19-1.91 c0.16-0.23,0.29-0.47,0.47-0.71c0.05-0.09,0.11-0.19,0.17-0.28c0.11-0.17,0.22-0.34,0.33-0.51c0.14-0.23,0.29-0.47,0.45-0.7 c0.11-0.17,0.22-0.34,0.33-0.51c2.37-3.67,5.33-8.03,8.17-11.65c0.26-0.31,0.51-0.62,0.76-0.93c1.13-1.4,2.23-2.64,3.27-3.64 c0.12-0.12,0.25-0.25,0.37-0.37c0.43-0.4,0.85-0.78,1.26-1.09c0.19-0.14,0.36-0.26,0.54-0.39c0.23-0.16,0.45-0.28,0.65-0.39 c0.09-0.06,0.2-0.11,0.29-0.16c1.16-0.51,2.06-0.34,2.57,0.81C716.72,221.7,713.56,232.43,711.28,237.13z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 672.5959,
    y1: 231.0811,
    x2: 650.5018,
    y2: 180.5193
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#867567"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    style: {
      stopColor: "#885439"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8A3813"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 655.7,
    cy: 192.41,
    r: 24.03
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 655.7,
    cy: 192.41,
    r: 20.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 648.6885,
    y1: 176.4967,
    x2: 667.2433,
    y2: 214.916
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DC9263"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8A3813"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 657.24,
    cy: 194.19,
    r: 15.68
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 659.52,
    cy: 195.64,
    r: 11.45
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 663.45,
    cy: 189.78,
    r: 2.05
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M690.44,237.91l0.06-0.02c-0.12,0.2-0.22,0.36-0.26,0.43c0.03-0.08,0.11-0.22,0.19-0.42H690.44z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 658.9169,
    y1: 236.6089,
    x2: 676.7733,
    y2: 292.9254
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DC9263"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8A3813"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M711.28,237.13c-0.34,0.7-0.7,1.4-1.07,2.08c-0.33,0.62-0.68,1.24-1.04,1.86c-0.11,0.19-0.23,0.39-0.34,0.57 c-0.34,0.56-0.68,1.12-1.04,1.67c0,0.02-0.02,0.02-0.02,0.03c-0.36,0.56-0.73,1.12-1.12,1.67c-1.52,2.23-3.18,4.42-4.98,6.56 c-0.43,0.51-0.87,1.01-1.3,1.5c-0.06,0.08-0.12,0.14-0.19,0.22c-0.25,0.29-0.51,0.57-0.78,0.87c-0.43,0.48-0.87,0.96-1.32,1.44 c-2.28,2.45-4.73,4.85-7.29,7.18c-0.48,0.45-0.96,0.88-1.44,1.3c-24.58,21.8-58.95,37.84-69.93,42.07 c1.01-14.61,3.53-25.64,10.29-33.92c8.52-10.43,35.11-26.01,40.35-28.12c0,0.02,0,0.02,0,0.03c1.3,4.08,6.05,5.97,9.97,4.28 c3.64-1.55,7.94-5.94,10.14-10.02l0.06,0.09l0.25-0.62c0.11-0.17,0.23-0.39,0.39-0.64c0.09-0.16,0.2-0.34,0.33-0.54 c0.12-0.19,0.25-0.4,0.39-0.64c0.12-0.2,0.26-0.43,0.4-0.67c0.36-0.57,0.76-1.21,1.19-1.91c0.16-0.23,0.31-0.48,0.47-0.71 c0.05-0.09,0.11-0.19,0.17-0.28c0.11-0.17,0.22-0.34,0.33-0.51c0.14-0.23,0.29-0.47,0.45-0.7c0.11-0.17,0.22-0.34,0.33-0.51 c2.37-3.67,5.33-8.03,8.17-11.65c0.26-0.33,0.51-0.64,0.76-0.93c1.13-1.4,2.23-2.64,3.27-3.64c0.12-0.12,0.25-0.25,0.37-0.37 c0.43-0.4,0.85-0.78,1.26-1.09c0.19-0.14,0.37-0.26,0.54-0.39c0.23-0.16,0.45-0.28,0.65-0.39c0.09-0.06,0.2-0.11,0.29-0.16 c1.16-0.51,2.06-0.34,2.57,0.81C716.72,221.7,713.56,232.43,711.28,237.13z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.2238,
    y1: -1.8353,
    x2: 346.12,
    y2: 74.9248
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#461C0A",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8A3813",
      stopOpacity: 0
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M491.33,38.85c0,0-4.05,4.4-9.26,11.46c0,0-66.41-18.86-113.61-1.26c-15.44,5.75-28.81,19.94-40.67,30.49 c-11.85,10.54-50.6-3.47-60.16-3.66c-11.55-0.23-27.68,16.84-36.89,26.5c-9.23,9.66-15.94,21.15-31.25,14.08 c6.59-9.64,15.74-29.46,29.96-31.38c14.23-1.94,6.61-34.64,71.62-48.36c65.03-13.71,102.62-12.19,142.75-8.13 c15.89,1.61,31.46,5.13,47.48,10.25L491.33,38.85z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 268.8732,
    y1: 274.5016,
    x2: 236.0675,
    y2: 390.9618
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M373.17,306.21c2.71,4.33,5.5,9.68,5.37,14.75v0.02c-0.14-0.02-0.28-0.02-0.42-0.03 c-0.53-0.02-1.05-0.03-1.55-0.03c-9.13,0-11.16,1.77-43.84,14.02h-0.02c-1.83,0.68-3.75,1.41-5.78,2.16 c-3.86,1.44-8.11,3.01-12.76,4.7c-6.99,2.54-14.27,4.39-21.62,5.66c-0.02,0-0.02,0-0.02,0c-1.26,0.25-2.53,0.45-3.8,0.64 c-9.86,1.47-19.79,2-29.26,1.91h-0.02c-1.01,0-1.98-0.02-2.98-0.03c-11.8-0.28-22.81-1.44-32.02-2.81c-0.9-0.14-1.78-0.28-2.64-0.4 c-0.02,0-0.02,0-0.02,0c-14.47-2.29-23.9-4.96-23.9-4.96c-2.47-0.17-4.85-0.4-7.15-0.67c-0.82-0.11-1.64-0.2-2.45-0.31 c-0.02,0-0.02,0-0.02,0c-14.11-1.94-24.81-5.71-32.64-10c-0.39-0.22-0.78-0.43-1.15-0.65c-11.96-6.9-16.82-15.01-16.82-19.21 c0-0.53,0.02-1.12,0.06-1.77v-0.02c0.02-0.47,0.05-0.96,0.09-1.5c0.5-5.72,2.31-14.89,7.38-24.38h0.02 c0.45-0.85,0.93-1.71,1.44-2.56c3.19-5.37,7.51-10.76,13.24-15.6c3.63-3.05,12.9-6.65,21.93-9.66c10.78-3.61,21.2-6.37,21.2-6.37 s0.7,2.48,2.37,6.37c0.64,1.47,1.41,3.13,2.34,4.95c1.54,2.98,3.49,6.34,5.94,9.85c0.99,1.44,2.09,2.9,3.26,4.37 c2.67,3.3,5.77,6.62,9.37,9.77c1.32,1.15,2.7,2.28,4.14,3.36c4.43,3.33,9.51,6.36,15.3,8.78c1.66,0.7,3.4,1.35,5.18,1.95 c6.11,2.02,12.95,3.4,20.58,3.86c2,0.12,4.05,0.19,6.17,0.19c6.45-0.02,13.44-0.68,21-2.11c0.11-0.02,0.23-0.05,0.34-0.06 c2.08-0.4,4.05-0.76,5.95-1.1c8.65-1.52,15.61-2.45,21.31-2.92c2.06-0.16,3.94-0.26,5.69-0.31c8.03-0.25,13.04,0.65,16.99,2.02 c1.8,0.6,3.4,1.32,4.96,2.06c2.64,1.27,5.23,2.62,8.64,3.78C365.38,304.86,368.75,305.69,373.17,306.21z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M452.5,323.61c-37.72,28.33-87.41,15.07-87.41,15.07c-3.98-0.94-4.51-2.01,2.94-5.18 c1-0.43,1.9-0.85,2.72-1.32c0.41-0.23,0.8-0.47,1.2-0.7c0.37-0.23,0.73-0.48,1.06-0.73c0.36-0.26,0.69-0.52,1.02-0.78 c0.27-0.23,0.55-0.48,0.8-0.73c0.34-0.33,0.66-0.66,0.93-0.99c0.16-0.21,0.33-0.41,0.48-0.59c0.16-0.23,0.34-0.47,0.49-0.71 c0.15-0.26,0.32-0.51,0.45-0.78c0.11-0.19,0.22-0.4,0.29-0.6c0.19-0.37,0.34-0.76,0.47-1.14c0.1-0.26,0.18-0.54,0.23-0.81 c0.08-0.29,0.14-0.56,0.19-0.87c0.06-0.26,0.08-0.54,0.1-0.8c0.03-0.04,0.03-0.08,0.03-0.12c0.03-0.29,0.04-0.55,0.04-0.82v-0.01 c0.14-5.07-2.65-10.42-5.36-14.75c-1.7-2.75-3.26-5.16-4.26-6.71c-9.84-15.16-6.09-30.34,6.37-32.07c4.39-0.6,11.3,0.51,18.42,2.24 c14.38,3.46,26.05,13.68,31.91,27.28C429.98,307.09,437.99,318.55,452.5,323.61z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M66.14,261.97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.5059,
    y1: 159.6844,
    x2: 28.0194,
    y2: 62.9899
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M159.89,124.46c-2.25,4.95-6.48,8.67-11.51,10.22c-1.69,0.53-3.47,0.81-5.29,0.81h-0.51 c-0.17-0.02-0.34-0.02-0.51-0.02c-4.12-0.05-9.06,0.78-14.34,3.52c0,0,0,0-0.02,0c-1.54,0.79-3.09,1.74-4.67,2.87 c-2.87,2.08-5.78,4.76-8.7,8.2c-0.14,0.17-0.29,0.34-0.43,0.51c-1.19,1.41-2.31,2.78-3.38,4.09c-2.34,2.9-4.4,5.57-6.26,8 c-1.16,1.52-2.25,2.95-3.26,4.28c-3.29,4.3-5.95,7.69-8.67,10.23c-1.46,1.36-2.93,2.48-4.53,3.36c-0.7,0.39-1.41,0.73-2.16,1.01 c-2.45,0.99-5.26,1.49-8.68,1.52h-0.02c-0.17,0.02-0.33,0.02-0.5,0.02c-6.79,0-10.85-0.93-13.34-2.47 c-3.55-2.17-3.91-5.57-4.47-9.2c-0.48-3.01-6.61,1.78-11.43,8.65c-0.81,1.13-1.58,2.33-2.28,3.55c-2.03,3.55-3.52,7.35-3.67,10.78 c-10.3-0.28-21.96,0.82-33.77,4.74c0.73-1.71,1.5-3.5,2.33-5.38c0.67-1.54,1.38-3.12,2.11-4.76c0.17-0.34,0.33-0.7,0.48-1.05 c0.31-0.67,0.62-1.33,0.93-2.02c0.06-0.12,0.11-0.26,0.17-0.39c0.26-0.56,0.51-1.12,0.78-1.67c0.31-0.67,0.64-1.36,0.96-2.05 c0.79-1.69,1.58-3.4,2.42-5.13c0.91-1.94,1.88-3.91,2.84-5.89c0.76-1.57,1.54-3.13,2.31-4.7c0.9-1.8,1.8-3.61,2.71-5.41 c0.33-0.64,0.65-1.27,0.96-1.92c0.93-1.8,1.85-3.6,2.79-5.38c1.35-2.57,2.7-5.15,4.08-7.68c0.62-1.16,1.24-2.33,1.88-3.47 c0.31-0.57,0.64-1.15,0.95-1.71c0.08-0.14,0.16-0.29,0.25-0.43c1.02-1.85,2.05-3.66,3.05-5.43c0.34-0.6,0.68-1.19,1.02-1.77 c0.34-0.59,0.67-1.16,1.01-1.74c0.34-0.57,0.67-1.15,1.01-1.71c0.96-1.63,1.91-3.21,2.85-4.73c0.29-0.48,0.59-0.96,0.88-1.43 c1.38-2.2,2.73-4.3,4.05-6.23c0.31-0.47,0.62-0.91,0.91-1.35c0.7-1.02,1.38-1.98,2.06-2.93c0.79-1.1,1.58-2.14,2.36-3.1 c0.28-0.36,0.56-0.7,0.84-1.04c0-0.02,0.02-0.03,0.02-0.03c0.22-0.26,0.42-0.5,0.62-0.74c0.06-0.08,0.12-0.14,0.19-0.2 c0.22-0.28,0.45-0.53,0.67-0.78c0.05-0.05,0.08-0.09,0.12-0.14c0.4-0.45,0.81-0.88,1.22-1.3c0.82-0.85,1.69-1.66,2.57-2.4 c0.5-0.42,0.99-0.82,1.5-1.21c0.51-0.39,1.02-0.76,1.54-1.13c3.13-2.17,6.51-3.86,9.94-5.16c0.59-0.23,1.18-0.45,1.77-0.65 c8.59-2.98,17.41-3.72,23.71-3.86c0.87-0.03,1.69-0.03,2.47-0.03h0.6c3.23,0.02,6.36,0.96,9.07,2.71 c9.09,5.89,31.2,20.24,41.7,27.03c0.22,0.16,0.42,0.29,0.64,0.42c0.11,0.08,0.23,0.16,0.34,0.22c0.5,0.33,0.95,0.62,1.36,0.88 c1.47,0.96,2.53,1.66,3.02,1.97c0.08,0.05,0.14,0.09,0.19,0.12c0.05,0.03,0.09,0.06,0.11,0.08 C159.88,124.46,159.89,124.46,159.89,124.46z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.3437,
    y1: 230.2918,
    x2: 154.252,
    y2: 294.2038
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M147.72,263.84c-0.29,0.47-0.6,0.93-0.9,1.41l-0.02,0.02c-0.29,0.48-0.6,0.96-0.9,1.46 c-1.77,2.84-3.61,5.97-5.63,9.2c-0.42,0.68-0.85,1.36-1.3,2.06c-2.99,4.65-6.37,9.41-10.44,13.8c-0.47,0.51-0.96,1.02-1.46,1.54 c-0.02,0.03-0.05,0.05-0.06,0.06c-0.5,0.51-1.02,1.02-1.55,1.52c-0.45,0.43-0.91,0.87-1.4,1.29c-0.68,0.6-1.38,1.19-2.09,1.78 c-0.54,0.43-1.12,0.87-1.69,1.3c-0.51,0.37-1.35,0.96-1.86,1.33c-0.11,0.08-0.22,0.15-0.34,0.23c-0.53,0.36-1.07,0.7-1.63,1.04 c-0.67,0.42-1.33,0.82-2.03,1.19c-0.7,0.39-1.4,0.76-2.12,1.12c-0.65,0.33-1.3,0.64-1.98,0.91c-0.19,0.09-0.36,0.17-0.54,0.25 c-0.65,0.28-1.3,0.54-1.98,0.79c-0.74,0.28-1.5,0.56-2.29,0.81c-0.08,0.03-0.16,0.05-0.23,0.08c-0.71,0.22-1.46,0.43-2.2,0.64 c-0.08,0.03-0.16,0.05-0.22,0.06c-0.73,0.19-1.47,0.37-2.22,0.53c-0.31,0.08-0.6,0.14-0.93,0.19c-0.67,0.16-1.36,0.28-2.06,0.39 c-35.57,5.71-74.23-40.41-84.77-43.48C2.32,262.25,0.57,253.03,1.89,246c1.32-7.02-4.84-15.37,0-32.05c0.11-0.4,0.25-0.82,0.4-1.29 c1.02-3.23,2.84-7.89,5.23-13.51c11.82-3.92,23.48-5.02,33.77-4.74c-0.14,2.88,0.65,5.49,2.81,7.46c1.44,1.32,3.01,2.51,4.65,3.61 c10.82,7.3,24.97,10.65,30.31,19.37C85.22,234.88,106.27,274.55,147.72,263.84z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 371.5626,
    y1: 261.4787,
    x2: 533.4294,
    y2: 261.4787
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M531.83,245.06c-0.64,1.21-1.54,2.54-2.61,4.05c-3.8,5.4-9.57,13.06-12.17,25.59 c-0.11,0.54-0.22,1.1-0.31,1.67c-0.48,2.76-1.33,5.75-2.47,8.84c-2.68,7.38-6.88,15.24-11.2,21.63 c-5.06,7.47-10.25,12.92-13.4,13.18c-4.65,0.41-26.88,2.58-40.93,3.96c-9.87,0.97-19.72-2.1-27.23-8.57 c-0.24-0.21-0.49-0.42-0.73-0.64c-0.65-0.57-1.3-1.15-1.94-1.75c-5.55-5.21-10.75-11.49-15.51-18.34c-0.37-0.53-0.73-1.07-1.09-1.6 c-3.72-5.49-7.16-11.3-10.28-17.21c-0.33-0.59-0.65-1.19-0.96-1.8c-3.26-6.28-6.16-12.61-8.67-18.72 c-0.34-0.82-0.67-1.66-0.99-2.48c-2.78-6.95-4.99-13.54-6.62-19.29c-0.28-0.96-0.53-1.89-0.78-2.79c-2.4-9.26-3.07-15.92-1.67-17.8 c3.29-4.42,27.32-11.63,50.32-13.65c1.61-0.14,3.21-0.25,4.81-0.34h0.02c9.74-0.54,19.01-0.02,26.08,2.2 c3.18,0.98,5.91,2.31,8.05,4.05c0.59,0.48,1.15,0.99,1.64,1.54c3.1,3.38,7.15,6.39,11.66,9.06c2.51,1.47,5.18,2.85,7.89,4.14 c6.42,2.98,13.21,5.38,19.27,7.23c3.36,1.04,6.51,1.89,9.24,2.59c6.19,1.58,10.33,2.33,10.33,2.33c4.62,1.07,7.63,2.28,9.46,3.67 C534.4,238.31,533.78,241.37,531.83,245.06z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M531.83,245.06c-3.01,5.72-12.05,14.16-15.09,31.31c-1.66,9.4-7.55,21.43-13.66,30.47 c-23.86,1.64-31.12-11.39-34.35-20.9c-9.95-29.35-46.1-29.6-46.13-86.59c1.61-0.14,3.21-0.25,4.81-0.34h0.02 c15.32-0.85,29.48,0.93,35.77,7.78c16.25,17.71,58.4,25.34,58.4,25.34C534.7,235.16,534.84,239.35,531.83,245.06z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 544.5773,
    y1: 99.612,
    x2: 627.1722,
    y2: 108.8998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#867567"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    style: {
      stopColor: "#885439"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8A3813"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M620.54,106.73c-10,9.51-17.6,18.19-22.58,26.3c-10.64-8.5-15.83-21.6-18.36-33.12v-0.02 c-2.85-13.01-2.29-24-2.29-24c2.28,1.23,4.53,2.51,6.75,3.85C597.51,87.78,609.92,97.41,620.54,106.73z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 669.7072,
    y1: 218.354,
    x2: 704.3476,
    y2: 218.354
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8A3813"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M690.24,238.33c0.84-1.85,14.58-32.02,14.1-36.97c-0.34-3.49-2.95-8.31-6.76-13.71h-0.02 c0,0,3.44,13.85-12.54,34.75c-9.66,12.64-17.09,15.03-14.93,21.76c1.3,4.08,6.05,5.97,9.97,4.28c3.64-1.55,7.94-5.94,10.14-10.02 l0.06,0.09l0.25-0.61C690.38,238.09,690.29,238.24,690.24,238.33z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 628.5778,
    y1: 204.12,
    x2: 593.2028,
    y2: 286.0646
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8A3813"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M598.21,215.89c-6.51-0.78-22.17,8.15-14.66,24.43c6.15,13.33,22.95,4.65,21.94,17.79 c-1.18,15.28,21.78,8.99,25.52-7.67c3.51-15.59,14.84-0.26,18.24-10.12c2.38-6.88-5.08-20.61-20.08-13.58 c-10.7,5.01-11.2,14.81-17.93,7.44C603.2,225.38,605.87,216.8,598.21,215.89z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M159.89,124.46c0,0,4.67,1.47,11.32,1.61c-21.41,39.62-68.01,68.54-85.55,55.48 c-4.67-3.46-7.29-9.88-6.82-19.86c1.44-31.34,11.32-51.56,21.52-70.65c0,0,0-0.02,0.02-0.03c0.87-0.02,1.69-0.02,2.45,0h0.6 c3.23,0.02,6.36,0.96,9.07,2.71c9.09,5.89,31.2,20.24,41.7,27.03c0.22,0.16,0.42,0.29,0.64,0.42c0.11,0.08,0.23,0.16,0.34,0.22 c0.5,0.31,0.95,0.6,1.36,0.88c1.47,0.96,2.53,1.66,3.02,1.97c0.08,0.05,0.14,0.09,0.19,0.12c0.05,0.03,0.09,0.06,0.11,0.08 C159.88,124.46,159.89,124.46,159.89,124.46z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M207.56,103.62c-1.02,1.57-2,3.12-2.93,4.64c-20.45-23.01-66.38-28.16-80.17-36.87 c0.36-0.26,0.71-0.53,1.09-0.79C141.16,78.41,188.86,82.38,207.56,103.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M223.08,87.22c-1.57,0.84-3.05,1.89-4.48,3.09c-19.99-19.18-58.27-24.93-74.2-32.35 c0.5-0.31,1.01-0.64,1.54-0.95C163.94,63.74,205.03,68.49,223.08,87.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M240.82,73.17c-1.04,1.71-1.97,3.29-2.85,4.71c-17.13-19.23-52.12-25.96-71.1-32.76 c0.73-0.39,1.47-0.78,2.22-1.16C189.54,49.88,225.16,55.57,240.82,73.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M255.51,55.91c-1.46,1.18-2.79,2.36-4.02,3.55c-15.37-14.31-41-21.03-59.3-26.67 c1.07-0.48,2.16-0.95,3.24-1.43C215.07,36.34,241.46,42.33,255.51,55.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M275.42,44.25c-0.05,0.08-0.11,0.14-0.14,0.22c-1.67,0.68-3.27,1.4-4.79,2.14 c-12.09-12.84-32.22-19.96-49.65-25.34c1.55-0.57,3.12-1.13,4.7-1.67C244.33,24.57,265.09,31.35,275.42,44.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M303.33,36.23c-0.74,0.17-1.5,0.33-2.26,0.48c-1.32,0.28-2.61,0.56-3.86,0.85 c-13.21-12.41-34.14-19.13-51.42-24.38c1.64-0.48,3.3-0.95,4.98-1.38C269.88,16.7,292.01,23.26,303.33,36.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M330.65,31.21c-2.06,0.33-4.16,0.67-6.28,1.04c-11.63-12.03-29.42-20.36-44.52-27.07 c1.64-0.31,3.27-0.6,4.93-0.88C301.45,10.85,320.26,19.07,330.65,31.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M354.16,28.03c-2.08,0.22-4.2,0.47-6.36,0.73c-10.54-11.27-25.51-20.2-38.29-27.62 c1.6-0.17,3.21-0.29,4.82-0.39c0,0,0,0,0.02,0C328.42,8.11,344.23,16.93,354.16,28.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M377.01,26.2c-2.11,0.11-4.23,0.23-6.4,0.37c-8.45-10.36-20.48-19.09-31.73-26.53 c1.97,0.02,3.92,0.06,5.91,0.16h0.02C356.9,7.56,369.28,16.15,377.01,26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M403.48,25.86c-2.17-0.06-4.36-0.09-6.57-0.09c-6.75-8.64-15.74-16.33-24.61-23.15 c2.33,0.29,4.61,0.62,6.85,0.95C388.4,10.21,397.33,17.66,403.48,25.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M429.78,27.29c-2.12-0.17-4.25-0.34-6.37-0.48c-4.5-6.45-10-12.54-15.68-18.2c1.72,0.36,3.4,0.73,5.05,1.1 c0.57,0.12,1.12,0.26,1.67,0.39C420.2,15.52,425.58,21.29,429.78,27.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M455.94,30.2c-2.16-0.36-4.31-0.67-6.47-0.95c-2.78-4.25-5.95-8.37-9.33-12.33c0.11,0.03,0.2,0.06,0.29,0.09 c0.85,0.25,1.67,0.51,2.5,0.78c1.6,0.51,3.15,1.01,4.65,1.52h0.02C450.68,22.85,453.54,26.48,455.94,30.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M207.76,260.41c-16.44,12.65-44.16,17.91-62.52,22.87c0.45-0.85,0.93-1.71,1.44-2.56 c17.57-5.49,42.72-11.85,58.74-25.26C206.06,256.93,206.83,258.59,207.76,260.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M216.96,274.63c-18.84,20.59-64.32,26.33-79.21,34.53c0.02-0.47,0.05-0.96,0.09-1.5 c14.36-8.65,56.16-15.71,75.86-37.4C214.69,271.7,215.79,273.15,216.96,274.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M230.46,287.76c-16.37,22.5-60.77,33.26-74.8,43.05c-0.39-0.22-0.78-0.43-1.15-0.65 c12.11-10.3,53.93-21.82,71.81-45.76C227.64,285.54,229.02,286.68,230.46,287.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M250.95,298.49c-13.65,18.9-44.22,32.41-60.18,42.63c-0.82-0.11-1.64-0.2-2.45-0.31 c13.97-10.44,42.81-24.33,57.45-44.27C247.43,297.24,249.16,297.89,250.95,298.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M277.7,302.54c-10.98,18.48-37.14,33.42-53.23,44.61c-0.9-0.14-1.78-0.28-2.64-0.4 c13.97-10.99,37.6-25.68,49.7-44.39C273.52,302.48,275.57,302.54,277.7,302.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M304.99,299.27c-7.3,19.4-30.28,37.34-45.51,50.72h-0.02c-1.01,0-1.98-0.02-2.98-0.03 c13.04-12.78,33.45-29.97,42.21-49.53c0.11-0.02,0.23-0.05,0.34-0.06C301.11,299.96,303.08,299.61,304.99,299.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M331.98,296.04c-5.06,18.78-24.79,37.18-39.43,51.4c-0.02,0-0.02,0-0.02,0c-1.26,0.25-2.53,0.45-3.8,0.64 c12.87-13.83,31.21-32.05,37.56-51.73C328.35,296.2,330.23,296.09,331.98,296.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M353.94,300.12c-3.61,11.89-12.22,23.93-21.21,34.81h-0.02c-1.83,0.68-3.75,1.41-5.78,2.16 c9.07-11.78,18.27-25.26,22.05-39.03C350.78,298.66,352.37,299.38,353.94,300.12z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M517.05,274.69c-0.11,0.54-0.22,1.1-0.31,1.67c-0.48,2.76-1.33,5.75-2.47,8.84 c-29.93,15.6-71.48,21.86-93.49,29.57c-0.65-0.57-1.3-1.15-1.94-1.75C441.02,303.58,486.33,295.47,517.05,274.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M511.27,229.8c-29.11,28.7-94.28,35.26-119.29,46.07c-0.33-0.59-0.65-1.19-0.96-1.8 c22.1-11.3,79.04-19.52,111.01-46.86C505.39,228.25,508.54,229.1,511.27,229.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M482.75,219.98c-27.6,19.89-73.81,27.29-100.4,35.37c-0.34-0.82-0.67-1.66-0.99-2.48 c24.16-8.67,65.45-17.26,93.5-37.03C477.37,217.32,480.04,218.7,482.75,219.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M461.55,205.25c-26.1,14.75-62.65,21.57-86.82,28.33c-0.28-0.96-0.53-1.89-0.78-2.79 c21.86-7.24,54.21-14.93,79.55-29.59C456.68,202.18,459.41,203.52,461.55,205.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M531.83,245.06c-0.64,1.21-1.54,2.54-2.61,4.05c-35.8,27.35-103.66,33.6-125.88,45.57 c-0.37-0.53-0.73-1.07-1.09-1.6c21.49-14.03,93.53-22.33,128.8-57.28C534.4,238.31,533.78,241.37,531.83,245.06z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M148.39,134.68c-1.69,0.53-3.47,0.81-5.29,0.81h-0.51c-0.17-0.02-0.34-0.02-0.51-0.02 c-17.96-20.22-53.03-30.7-67.19-39.91c0.59-0.23,1.18-0.45,1.77-0.65C93.39,103.93,132.68,114.15,148.39,134.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M127.72,138.99c-1.54,0.79-3.09,1.74-4.67,2.87c-20.42-17.34-53.78-25.65-65.92-33.97 c0.29-0.34,0.57-0.67,0.85-0.98C71.59,114.8,107.78,122.39,127.72,138.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M113.92,150.58c-1.19,1.41-2.31,2.78-3.38,4.09c-18.5-15.89-49.03-23-65.14-29.93 c0.29-0.48,0.59-0.96,0.88-1.43C63.51,129.64,95.85,135.8,113.92,150.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M104.27,162.67c-1.16,1.52-2.25,2.95-3.26,4.28c-18.02-14.56-47.57-19.54-65.76-24.7 c0.31-0.57,0.64-1.15,0.95-1.71C55.61,145.01,87,148.92,104.27,162.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M92.35,177.19c-1.46,1.36-2.93,2.48-4.53,3.36c-17.68-12.16-44.22-15.96-62.27-19.85 c0.33-0.64,0.65-1.27,0.96-1.92C46.23,162.05,75.43,164.87,92.35,177.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M15.27,181.84c9.32-0.54,20.61-1.61,31.97-1.75c-0.81,1.13-1.58,2.33-2.28,3.55 c-11.04-0.33-21.82,0.2-30.66,0.25C14.62,183.22,14.94,182.52,15.27,181.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M76.97,183.08c-0.17,0.02-0.33,0.02-0.5,0.02c-6.79,0-10.85-0.93-13.34-2.47 C67.97,181.08,72.64,181.85,76.97,183.08z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M135.87,265.62c-16.22,17.83-47.49,28.72-68.8,37.6c-0.95-0.44-1.91-0.91-2.85-1.39 c18.46-8.87,45.82-19.67,63.27-36.61C130.16,265.57,132.95,265.73,135.87,265.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M111,259.75c-18.97,14.06-47.68,22.38-66.49,29.64c-0.7-0.52-1.4-1.04-2.09-1.55 c17.23-7.74,44.01-16.7,63.12-31.47C107.27,257.59,109.08,258.71,111,259.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M94.24,246.31c-19.54,13.83-49.71,20.79-69.61,27.15c-0.71-0.58-1.4-1.14-2.08-1.68 c18.67-7.11,47.76-15.03,67.7-30.15C91.49,243.19,92.82,244.76,94.24,246.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M82.76,230.94c-21.67,14.74-56.42,19.88-80.3,25.01c-0.29-0.85-0.51-1.72-0.66-2.6 c22.63-5.98,55.42-12.46,77.37-28.33C80.05,226.47,81.24,228.54,82.76,230.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M67.37,215.38c-18.62,10.76-45.99,14.27-66.9,17.5c-0.12-0.87-0.23-1.77-0.32-2.72 c18.55-3.74,42.26-8.06,60.53-18.11h0.01C62.99,213.17,65.24,214.25,67.37,215.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M46.7,204.01c-13.95,3.19-29.45,4.22-43.16,5.03c0.37-1,0.78-2.09,1.25-3.24 c11.92-1.28,25.13-2.91,37.53-6.17c0.45,0.81,1.03,1.57,1.77,2.24C44.92,202.62,45.8,203.34,46.7,204.01z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.4018,
    y1: 309.4714,
    x2: 242.6524,
    y2: 348.4138
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#333813"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M362.58,303.9c-6.34,3.71-15.34,7.13-27.57,9.41c-38.18,7.09-49.78,12.07-96.03,8.23 c-40.3-3.36-54.21-54.98-57.12-66.08c10.78-3.61,21.2-6.37,21.2-6.37s18.48,66.1,95.98,51.28 C348.65,290.88,348.44,299.1,362.58,303.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6345,
    y1: 202.6133,
    x2: 525.5541,
    y2: 81.2926
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8A3813"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M579.6,99.89v0.02c-19.85-0.51-29.71,13.49-29.71,13.49s-16.06,19.35-29.03,26.7 c-2.42,1.35-4.71,2.29-6.79,2.62c-13.26,2.11-36.13,3.61-29.2,14.45c6.92,10.84,18.05,15.49,26.24,25.9 c10.19,12.98,6.25,24.27-6.99,25.77c-13.24,1.5-15.66,6.93-13.54,14.25l-3.74-1.3c-1.38-0.57-2.74-1.18-4.09-1.8 c-2.71-1.29-5.38-2.67-7.89-4.14c-4.51-2.67-8.56-5.68-11.66-9.06c-0.5-0.54-1.05-1.05-1.64-1.54c-2.14-1.74-4.87-3.07-8.05-4.05 c-7.07-2.22-16.34-2.74-26.08-2.2h-0.02c-1.58,0.09-3.18,0.2-4.78,0.34c2.54-29.97,23.68-32.59,36.72-43.87 c13.04-11.29,1.75-17.48,0.06-48.75c-1.69-31.29,31.91-67.87,31.91-67.87c24.41,7.8,49.84,19.32,78.97,33.42 c2.36,1.15,4.7,2.34,7.01,3.61C577.31,75.88,576.75,86.88,579.6,99.89z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 539.5676,
    y1: 50.908,
    x2: 496.6696,
    y2: 147.2959
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#461C0A",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8A3813",
      stopOpacity: 0
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M579.6,99.89v0.02c-19.85-0.51-29.71,13.49-29.71,13.49s-5.44,6.54-12.54,13.49 c-25.01-16.02-54.66-30.75-74.97-40.19c7.99-25.01,28.95-47.84,28.95-47.84c24.41,7.8,49.84,19.32,78.97,33.42 c2.36,1.15,4.7,2.34,7.01,3.61C577.31,75.88,576.75,86.88,579.6,99.89z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.2028,
    y1: 142.6476,
    x2: 246.3295,
    y2: 359.294
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M310.29,58.62c-1.77,1.28-3.79,1.5-4.51,0.5c-0.72-1,0.13-2.84,1.9-4.12c1.77-1.28,3.79-1.5,4.51-0.5 C312.91,55.5,312.06,57.34,310.29,58.62z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.8053,
    y1: 149.498,
    x2: 243.9319,
    y2: 366.1444
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M306.95,70.02c-1.77,1.28-3.79,1.5-4.51,0.5c-0.72-1,0.13-2.84,1.9-4.12c1.77-1.28,3.79-1.5,4.51-0.5 S308.72,68.74,306.95,70.02z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.0779,
    y1: 149.7616,
    x2: 245.2046,
    y2: 366.408
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M307.43,81.58c-1.66,2.88-4.3,4.46-5.89,3.54c-1.59-0.92-1.54-4,0.13-6.87s4.3-4.46,5.89-3.54 C309.14,75.63,309.09,78.71,307.43,81.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.2233,
    y1: 151.4487,
    x2: 253.35,
    y2: 368.0951
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M314.71,88.2c-0.76,2.51-2.8,4.12-4.56,3.58s-2.57-3-1.81-5.51c0.76-2.51,2.8-4.12,4.56-3.58 C314.66,83.22,315.47,85.69,314.71,88.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 314.0314,
    y1: 154.723,
    x2: 269.1581,
    y2: 371.3694
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M321.5,132.92c-1.74,1.96-4.27,2.57-5.64,1.35c-1.38-1.22-1.08-3.8,0.66-5.76c1.74-1.96,4.27-2.57,5.64-1.35 C323.53,128.38,323.24,130.96,321.5,132.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 341.3725,
    y1: 160.3861,
    x2: 296.4992,
    y2: 377.0325
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M343.72,163.3c-1.74,1.96-4.27,2.57-5.64,1.35c-1.38-1.22-1.08-3.8,0.66-5.76c1.74-1.96,4.27-2.57,5.64-1.35 C345.75,158.76,345.46,161.34,343.72,163.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 345.2135,
    y1: 161.1816,
    x2: 300.3402,
    y2: 377.8281
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M341.63,192.7c-1.74,1.96-4.27,2.57-5.64,1.35s-1.08-3.8,0.66-5.76c1.74-1.96,4.27-2.57,5.64-1.35 C343.67,188.16,343.37,190.74,341.63,192.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 381.0276,
    y1: 168.5997,
    x2: 336.1543,
    y2: 385.2461
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M377.58,199.5c-1.74,1.96-4.27,2.57-5.64,1.35c-1.38-1.22-1.08-3.8,0.66-5.76c1.74-1.96,4.27-2.57,5.64-1.35 C379.61,194.96,379.32,197.54,377.58,199.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.9752,
    y1: 62.2939,
    x2: 341.1019,
    y2: 278.9404,
    gradientTransform: "matrix(0.956 -0.2933 0.2933 0.956 -27.0251 219.9246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M367.38,211.49c-1.09,2.39-3.33,3.71-5,2.95c-1.67-0.76-2.15-3.32-1.06-5.7c1.09-2.39,3.33-3.71,5-2.95 C368,206.54,368.47,209.1,367.38,211.49z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 326.2733,
    y1: 157.2586,
    x2: 281.4001,
    y2: 373.9051
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M328.51,162.48c-0.93,2.04-3.04,3.07-4.71,2.31s-2.28-3.03-1.35-5.07s3.04-3.07,4.71-2.31 C328.83,158.17,329.43,160.44,328.51,162.48z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 312.0093,
    y1: 154.3041,
    x2: 267.136,
    y2: 370.9506
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M308.72,186.19c-0.93,2.04-3.04,3.07-4.71,2.31c-1.67-0.76-2.28-3.03-1.35-5.07s3.04-3.07,4.71-2.31 S309.65,184.16,308.72,186.19z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 556.5817,
    y1: -150.7987,
    x2: 511.7084,
    y2: 65.8478,
    gradientTransform: "matrix(0.222 -1.0192 1.1125 0.432 338.6322 793.594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M316.26,170.54c2.06,1.83,2.74,4.42,1.52,5.8s-3.88,1.01-5.94-0.81c-2.06-1.83-2.74-4.42-1.52-5.8 C311.54,168.35,314.2,168.72,316.26,170.54z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 312.8378,
    y1: 154.4757,
    x2: 267.9644,
    y2: 371.1222
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M315.4,150.25c-2.5,0.81-4.98,0.05-5.55-1.69c-0.57-1.75,0.99-3.82,3.49-4.64s4.98-0.05,5.55,1.69 C319.46,147.37,317.89,149.44,315.4,150.25z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.8432,
    y1: 154.0626,
    x2: 265.9699,
    y2: 370.709
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M328.04,87.05c-1.75,1.96-5.44,2.74-6.56,1.74c-1.12-1-0.61-3.39,1.14-5.35c1.75-1.96,4.07-2.74,5.19-1.74 S329.79,85.09,328.04,87.05z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.3,
    y1: 170.3131,
    x2: 344.4267,
    y2: 386.9596
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M404.01,93.32c-1.9-1.81-2.56-5.53-1.53-6.61c1.03-1.08,3.41-0.5,5.31,1.31s2.61,4.15,1.58,5.24 C408.34,94.35,405.92,95.13,404.01,93.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 394.8933,
    y1: 171.4717,
    x2: 350.02,
    y2: 388.1181
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M411.86,83.6c-1.9-1.81-2.56-5.53-1.53-6.61c1.03-1.08,3.41-0.5,5.31,1.31s2.61,4.15,1.58,5.24 C416.19,84.62,413.76,85.4,411.86,83.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 397.4391,
    y1: 171.999,
    x2: 352.5658,
    y2: 388.6454
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M398.29,151.63c1.4-2.22,4.91-3.61,6.18-2.81c1.27,0.8,1.16,3.24-0.24,5.47c-1.4,2.22-3.56,3.38-4.82,2.58 C398.14,156.07,396.89,153.85,398.29,151.63z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 295,
    y1: 150.7811,
    x2: 250.1267,
    y2: 367.4275
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M303.99,122.49c1.12-2.37,0.4-6.08-0.96-6.72c-1.35-0.64-3.36,0.76-4.48,3.14s-0.93,4.82,0.42,5.46 C300.33,125,302.87,124.86,303.99,122.49z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.3289,
    y1: 149.8136,
    x2: 245.4556,
    y2: 366.46
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M286.33,184.25c1-2.12,0.14-5.54-1.21-6.18c-1.35-0.64-3.26,0.56-4.27,2.69c-1,2.12-0.72,4.37,0.63,5.01 C282.84,186.4,285.33,186.38,286.33,184.25z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 337.1882,
    y1: 159.5194,
    x2: 292.3148,
    y2: 376.1658
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M325.92,229.06c1-2.12,0.14-5.54-1.21-6.18c-1.35-0.64-3.26,0.56-4.27,2.69c-1,2.12-0.72,4.37,0.63,5.01 C322.43,231.21,324.92,231.18,325.92,229.06z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.6832,
    y1: 161.9003,
    x2: 303.8099,
    y2: 378.5468
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M333.53,250.15c1.16-2.44,0.47-6.23-0.88-6.87s-3.39,0.82-4.54,3.27s-1,4.94,0.36,5.58 C329.82,252.77,332.38,252.6,333.53,250.15z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 360.0386,
    y1: 164.2523,
    x2: 315.1653,
    y2: 380.8987
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M338.07,279.85c2.28-1.46,3.71-5.03,2.91-6.29c-0.81-1.26-3.31-1.1-5.58,0.35 c-2.28,1.46-3.47,3.66-2.66,4.92C333.53,280.09,335.79,281.3,338.07,279.85z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 340.2679,
    y1: 160.1572,
    x2: 295.3957,
    y2: 376.798
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M313.59,277.27c-1.16-2.44-0.47-6.23,0.88-6.87c1.35-0.64,3.39,0.82,4.54,3.27c1.16,2.44,1,4.94-0.36,5.58 C317.31,279.88,314.75,279.71,313.59,277.27z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.3997,
    y1: 148.5854,
    x2: 239.5263,
    y2: 365.2319
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M292.33,125.41c1.12-2.37,0.4-6.08-0.96-6.72c-1.35-0.64-3.36,0.76-4.48,3.14 c-1.12,2.37-0.93,4.82,0.42,5.46C288.67,127.92,291.21,127.78,292.33,125.41z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 272.5498,
    y1: 146.131,
    x2: 227.6765,
    y2: 362.7775
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M285.17,98.51c1.71-1.99,1.99-5.76,0.85-6.73c-1.14-0.97-3.44-0.15-5.15,1.84c-1.71,1.99-2.17,4.4-1.04,5.37 C280.97,99.97,283.46,100.51,285.17,98.51z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.9445,
    y1: 137.7206,
    x2: 187.0712,
    y2: 354.367
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M229.78,134.01c1.38,2.1,4.77,3.35,5.96,2.56s1.05-3.12-0.33-5.22c-1.38-2.1-3.47-3.16-4.66-2.37 C229.55,129.76,228.4,131.91,229.78,134.01z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 189.8956,
    y1: 132.9187,
    x2: 145.0223,
    y2: 349.5652
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M192.6,133.19c1.49-2.02,1.49-5.64,0.33-6.48c-1.15-0.85-3.29,0.1-4.78,2.13s-1.76,4.35-0.6,5.2 C188.7,134.88,191.12,135.21,192.6,133.19z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.6916,
    y1: 427.7538,
    x2: 243.8183,
    y2: 644.4003,
    gradientTransform: "matrix(0.712 0.7022 -0.7022 0.712 271.2521 -368.4297)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M178.15,140.93c2.48-0.4,5.01-2.97,4.79-4.38c-0.23-1.41-2.42-2.24-4.9-1.84c-2.48,0.4-4.31,1.86-4.08,3.28 C174.19,139.39,175.67,141.33,178.15,140.93z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 264.5218,
    y1: 144.4682,
    x2: 219.6485,
    y2: 361.1146
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M281.42,76.18c1.71-1.99,1.99-5.76,0.85-6.73c-1.14-0.97-3.44-0.15-5.15,1.84c-1.71,1.99-2.17,4.4-1.04,5.37 C277.22,77.63,279.71,78.17,281.42,76.18z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 267.9937,
    y1: 145.1873,
    x2: 223.1204,
    y2: 361.8338
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M289.72,52.14c-1.52,1.31-4.4,1.52-5.14,0.65c-0.74-0.87-0.11-2.63,1.41-3.93s3.36-1.66,4.1-0.79 C290.84,48.94,291.25,50.84,289.72,52.14z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 273.2766,
    y1: 146.2816,
    x2: 228.4033,
    y2: 362.928
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M280.02,128.87c1.12-2.37,0.4-6.08-0.96-6.72c-1.35-0.64-3.36,0.76-4.48,3.14 c-1.12,2.37-0.93,4.82,0.42,5.46C276.35,131.38,278.89,131.24,280.02,128.87z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 186.4688,
    y1: 128.3013,
    x2: 141.5955,
    y2: 344.9478
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M171.19,214.96c-0.76-2.51-3.28-4.93-4.37-4.6c-1.09,0.33-1.35,2.64-0.59,5.15 c0.76,2.51,2.26,4.28,3.35,3.95C170.67,219.13,171.95,217.47,171.19,214.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.0634,
    y1: 129.0459,
    x2: 145.1901,
    y2: 345.6923
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M170.86,233.56c0.7-2.08-0.09-5.04-1.17-5.41c-1.08-0.36-2.52,1.03-3.23,3.11c-0.7,2.08-0.4,4.07,0.68,4.43 C168.22,236.06,170.16,235.64,170.86,233.56z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.2973,
    y1: 121.2235,
    x2: 107.424,
    y2: 337.8699
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M140.43,191.19c-0.18-2.62-2.08-5.54-3.22-5.46c-1.14,0.08-1.91,2.26-1.73,4.88s1.24,4.68,2.38,4.6 C138.99,195.14,140.61,193.81,140.43,191.19z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 261.1912,
    y1: 143.7783,
    x2: 216.3179,
    y2: 360.4248
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M266.85,131.57c1.12-2.37,0.4-6.08-0.96-6.72c-1.35-0.64-3.36,0.76-4.48,3.14s-0.93,4.82,0.42,5.46 C263.19,134.08,265.73,133.94,266.85,131.57z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 311.5163,
    y1: 154.202,
    x2: 266.643,
    y2: 370.8485
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M341.02,43.72c0,0,3.67-5.96,3.67,0s-5.27,7.1-7.79,8.48c-2.52,1.37-4.58,6.87-3.9,8.71s0.88,3.67-2.2,4.35 c-3.07,0.69-9.71,9.39-9.37,12.83c0.34,3.44-4.7,5.04-4.7,1.15c0-3.9,2.29-2.75,3.67-8.94c1.37-6.19-0.59-5.88,4.63-9.01 c5.22-3.13,4.53-6.34,2.93-6.34c-1.6,0-1.15-2.52,0.92-3.44S341.02,43.72,341.02,43.72z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 318.6577,
    y1: 156.2581,
    x2: 273.7844,
    y2: 372.9046
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M334.77,71.15c-0.47,0.11-10.89,2.44-6.83,5.04s6.83-2.11,6.83,1.95s-5.2,13.17,1.46,10.24 s6.83-4.71,5.2-9.1c-1.63-4.39-1.46-4.71-0.33-6.67S336.85,70.67,334.77,71.15z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 400.0818,
    y1: 172.5463,
    x2: 355.2085,
    y2: 389.1928
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M420.38,93.01c-0.39-0.29-8.84-6.82-8.24-2.03c0.6,4.79,5.99,3.9,2.87,6.5c-3.13,2.6-13.45,4.42-6.94,7.67 c6.51,3.25,7.99,2.24,10.33-1.82c2.34-4.06,2.69-4.14,4.92-4.51S422.08,94.29,420.38,93.01z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 420.1501,
    y1: 176.703,
    x2: 375.2768,
    y2: 393.3495
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M444,98.96c0.29,0.39,1.81,11.58-2.98,10.98c-4.79-0.6-3.9-5.99-6.5-2.87c-2.6,3.13-4.42,13.45-7.67,6.94 c-3.25-6.51-2.24-7.99,1.82-10.33c4.06-2.34,4.14-2.69,4.51-4.92C433.55,96.54,440.58,94.29,444,98.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 1082.4242,
    y1: 30.8471,
    x2: 1037.5509,
    y2: 247.4936,
    gradientTransform: "matrix(-0.9631 -0.269 0.269 -0.9631 1355.3684 654.1722)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M351.42,258.1c-0.17-0.46,1.37-11.64,5.83-9.77c4.45,1.86,2.14,6.82,5.49,4.51 c3.34-2.31,7.88-11.77,9.26-4.62c1.38,7.15,0,8.3-4.53,9.46c-4.54,1.16-4.71,1.48-5.67,3.52 C360.83,263.24,353.46,263.51,351.42,258.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.29,
    y1: 168.4469,
    x2: 335.4167,
    y2: 385.0934
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M458.18,156.44c-13.09,10.49-33.06,13.8-35.54,42.91h-0.04c-5.16,0.45-10.38,1.17-15.4,2.05 c-31.23-4.75-38.34-20.14-39.87-23.45c-2.36-5.11-0.29-13.05-1.37-17.2c-1.09-4.17-4.89-3.26-7.8-3.26 c-2.89,0-2.53,2.71-0.18,5.79c2.35,3.08-0.71,4.88-3.79,3.99c-3.08-0.91-2.35-7.6-3.08-12.32c-0.73-4.7-4.17,0-7.6-0.91 c-3.44-0.89,0-2.71,1.18-4.7c1.18-1.99,0.63-4.34,0-9.95c-0.63-5.61,1.53-8.87,3.16-11.23c1.62-2.35,11.4-5.43,12.85-11.4 c1.44-5.98-3.81-2.72-6.7-0.37c-2.9,2.36-4.34,3.99-4.34-6.7s7.05-8.14,7.23-3.79c0.18,4.34,4.52-2.36,3.63-4.34 c-0.91-1.99,2.53-8.88,3.44-12.32c0.91-3.44-5.8-0.54-10.15,2.17c-4.34,2.72-4.15,6.89-6.32,9.42c-2.17,2.53-1.09-2.9-4.89,2.9 c-3.81,5.79-1.99,18.82-1.37,26.42c0.62,7.6-0.62,7.97-4.96,8.33c-4.34,0.36-1.44,4.34-1.21,11.77c0.25,7.42-2.41,6.87-6.02,3.62 c-3.6-3.26,1.07-7.05,0-6.7c-1.06,0.36-4.72,1.62-5.98-3.08c-1.26-4.7,4.34-4.7,6.87-4.88c2.54-0.19,1.81-6.34,0.78-12.32 c-1.03-5.97,2.12-8.51,4.34-11.59c2.24-3.07,0.67-7.78-3.31-6.52c-3.99,1.28-5.43,7.42-8.87,10.68 c-3.45,3.26-1.46-4.88,2.09-10.68c3.55-5.79,0.8-4.7-4.07-6.7c-4.88-1.99,0.89-3.79,4.07-8.14c3.19-4.34,6.6,1.44,8.62,4.34 c2.03,2.89,2.32-0.91,3.23-3.99c0.89-3.08,1.98-2.72,5.24-2.72c3.27,0,8.03-5.62,7.55-11.7c-0.52-6.38-1.75-0.96-4.1-7.3 c-2.36-6.34,4.81-7,5.61-6.82c5.14,1.21,4.08,9.6,4.65,15.76c0.58,6.15,5.11-1.04,6.39-2.39c1.28-1.35,6.26-2.64,4.83,3.05 c-1.42,5.68,4.69,5.54,6.82,3.97c2.13-1.57,7.96-1.99,6.82,1.09c-1.13,3.08,5.27,4.32,8.66,0.92c3.41-3.38,6.97,2.97,6.26,6.52 c-0.71,3.55,0,5.97,2.69,2.85c2.71-3.13,5.54,3.82,4.84,8.37c-0.71,4.55,7.66,9.94,13.91,3.55c6.26-6.39,4.12,6.39,4.12,10.23 c0,3.84,6.96,3.27,8.66,1c1.7-2.28,3.7,10.64,0.99,15.76c-2.69,5.11,1.28,7.11,0.43,13.21c-0.85,6.1-9.23-4.4-10.79-8.52 c-1.57-4.11-7.67-3.12-9.38,0.58c-1.7,3.68-4.11-0.15-3.26-3.27c0.85-3.12-1.7-2.69-6.26,1.28c-4.55,3.97-4.12,4.98-7.11,0.85 s-4.69,0.14-4.96,3.12c-0.29,2.98,3.97,10.09,2.69,15.34c-1.28,5.25,0.99,6.1,4.4,2.85c3.41-3.27,8.39,3.12,13.21,6.1 c4.83,2.98,0.29-4.4-0.14-9.8c-0.43-5.4,4.96-4.83,7.52-2.27c2.56,2.56,1.14,6.82,4.98,9.38c3.84,2.56,5.97-5.11,8.81-7.53 c2.83-2.42,3.26,2.42,1.42,6.68c-1.84,4.25,6.1,0.85,6.39-1.28c0.27-2.13,3.26-7.11,3.26-2.71c0,4.41,3.45,2.67,3.45,2.67 c9.6-4.17,6.34-6.89,8.33-8.33C454.6,154.15,456.43,154.97,458.18,156.44z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 374.9275,
    y1: 167.3362,
    x2: 330.0542,
    y2: 383.9826
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M392.8,70.65c0,0-8.13-3.55-9.17,1.15c-1.03,4.7,1.37,8.48,4.58,6.3c3.21-2.18,2.98,0,7.68,2.41 s6.64,4.58,7.22,1.49c0.57-3.09,1.26-5.38,2.18-7.79C406.2,71.79,397.84,67.78,392.8,70.65z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 278.4769,
    y1: 147.3587,
    x2: 233.6036,
    y2: 364.0051
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M294.53,56.83c0,0-3.89,7.65-1.15,8.94c2.74,1.29,3.02,4.89,1.73,6.91c-1.3,2.02-0.53,4.22,0.74,3.77 c1.27-0.46,1.46,3.58,0,5.59c-1.46,2.02,0.78,8.93,1.03,11.23c0.24,2.3,5.43,4.75,1.97,6.19c-3.46,1.44-5.55,3.46-6.45-1.01 c-0.9-4.46,2.56-8.5-2.48-8.64s-4.61,0.72-2.3-5.33s4.18-10.01,1.87-8.82c-2.3,1.19-4.9,2.2-2.74-2.7s2.3-7.53-0.14-7.22 c-2.45,0.31-3.46-6.46,2.59-8.91S294.53,56.83,294.53,56.83z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 289.3942,
    y1: 149.6199,
    x2: 244.5209,
    y2: 366.2664
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M304.54,127.06c2.47,2.14-3.9,9.38,0,13.09s-1.76,2.73-3.32,0s-13.48-1.97-14.26,2.43 c-0.78,4.41,0,7.53,2.54,13.98c2.54,6.45,3.39,9.18,2.87,12.31c-0.52,3.13-3.06,5.27-4.23,3.32c-1.17-1.95-3.13-9.77-5.18-4.88 c-2.05,4.88-6.15,11.72-4.98,3.52c1.17-8.2,1.56-7.42,2.54-11.33c0.98-3.91,1.76-5.17,0.2-8.64s2.93-6.99-1.95-9.92 s0.59-5.28,2.54-6.45c1.95-1.17,2.93,0,6.84,0S301.14,124.11,304.54,127.06z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 327.153,
    y1: 157.4408,
    x2: 282.2797,
    y2: 374.0872
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M302.56,203.22c0,0-5.04,3.04-2.52,8.6s1.32,5.79,2.52,9.39c1.2,3.6,3.6,0.24,4.79,0 c1.2-0.24,0.72,0.24,2.16,4.31s0,10.31,2.16,11.98c2.16,1.68,2.84-2.16,6.1-0.96s2.29,6.23,2.29,8.39c0,2.16,0.72,7.91,2.64,8.63 c1.92,0.72,4.07-1.44,5.03,2.64s3.36,10.07,2.64,12.22c-0.72,2.16-2.4,2.64-1.2,6.47c1.2,3.84-2.88,0.96-2.88,6.95 s-4.55,3.6-4.55,3.6s-1.2-1.68,0.72-4.79c1.92-3.12,4.07-10.07,1.68-15.1c-2.4-5.03-5.55-12.46-6.37-7.91 c-0.82,4.55-5.62,2.64-5.86-0.24c-0.24-2.88-6.95-8.87-9.11-2.88c-2.16,5.99,5.03,11.03,5.99,13.66c0.96,2.64-1.48,8.87-2.9,4.55 s-3.55-9.83-6.56-12.46c-3.01-2.64-7.95-5.99-8-11.03s2.11-10.55,3.31-13.18c1.2-2.64-2.64-4.07-0.72-13.9 c1.92-9.83,3.84-11.27,0-14.38c-3.84-3.12-3.6-5.95-1.56-6.93s2.52-4.81,7.67-4.57C305.19,196.52,302.56,203.22,302.56,203.22z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 280.1715,
    y1: 147.7097,
    x2: 235.2982,
    y2: 364.3561
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M363.07,304.07c-0.16-0.06-0.33-0.11-0.49-0.16c-3.41-1.17-5.99-2.52-8.63-3.78 c-1.57-0.74-3.16-1.46-4.96-2.06c-3.95-1.37-8.96-2.27-16.99-2.02c-1.75,0.04-3.63,0.15-5.69,0.32 c-5.69,0.47-12.65,1.39-21.31,2.91c-1.9,0.34-3.88,0.69-5.95,1.1c-0.11,0.01-0.23,0.04-0.34,0.05c-7.55,1.43-14.53,2.1-20.99,2.12 c-2.12,0-4.17-0.07-6.17-0.19c-3.6-0.22-7.03-0.65-10.28-1.25c-1.31-0.74-2.36-1.54-3.08-2.41c-5.17-6.23-12.81-21.89-19.4-23.32 c-6.5-1.4-18.86,0.32-22.27-1.35c-0.99-1.28-1.92-2.53-2.78-3.78c-0.21-0.3-0.41-0.59-0.62-0.89v-0.01 c-0.29-1.33-0.25-2.72,0.05-3.92c0.71-2.85,11.03,8.72,14.41-0.18c3.38-8.9-2.13-11.74-2.67-16.55 c-0.54-4.8,4.26-15.65,4.44-22.95c0.18-7.3-0.18-18.37-1.42-22.52c-1.25-4.17-6.05-1.5-6.59-5.6c-0.54-4.08-17.1-2.78-14.77,14.19 c1.21,8.74,6.5,10.24,9.14,14.7c2.64,4.47,1,5.09-1.22,18.68c-1.22,7.42-4.07,12.07-6.72,15.18c-0.93-1.8-1.69-3.45-2.34-4.92 c-1.68-3.89-2.36-6.37-2.36-6.37s-10.42,2.76-21.2,6.37c-9.03,3.01-18.3,6.61-21.93,9.66c-2.87,2.42-5.38,4.98-7.58,7.6 c-3.96-0.52-6.86-1.35-8.77-2.19c0.8-1.32,1.57-2.6,2.32-3.82c0.3-0.49,0.6-0.98,0.91-1.46l0.01-0.01 c0.29-0.48,0.6-0.95,0.89-1.42c-1.42,0.37-2.82,0.67-4.19,0.93c-0.45-1.62-1.4-3.85-1.5-6.38c-0.1-2.38,4.65-6.2,10.12-9.82 c1.31-0.88,2.67-1.75,4.01-2.57c0.51-0.32,1.02-0.62,1.51-0.92c1.46-0.88,2.87-1.72,4.18-2.46c2.61-1.51,4.73-2.69,5.75-3.3 c4.06-2.45,5.68-2.85,6.09,1.77c0.4,4.63,4.66,5.32,4.66,0c0-5.31,0.41-11.31-3.04-15.99c-3.45-4.66,3.04-14.61-2.85-19.27 c-5.88-4.67,0.21-8.13,4.67-5.88c4.45,2.23-0.21-2.64-2.03-7.11c-1.83-4.47,4.06-4.67,3.66-8.94c-0.41-4.26,5.88-17.05,8.73-23.87 c2.83-6.82,5.27-2.72,8.72-9.44c3.45-6.72,3.86,2.25,6.41,5.1c2.53,2.85-0.11,6.09,1.11,6.3c1.21,0.21,10.15-13.2,12.79-9.95 c2.64,3.26-3.45,6.3-5.88,9.35c-1.14,1.42-1.22,3.79-0.98,5.94c0.95-0.99,2.01-1.83,3.49-3.3c4.26-4.28,13.69-3.92,11.2-10.32 c-2.49-6.41-4.62-8.18-4.62-10.49s3.2-12.99,5.16-9.97c1.95,3.02,5.69,5.69,5.87,12.1c0.18,6.41,2.13,13.87,6.41,9.43 c4.26-4.45,1.24-11.92,1.42-16.02c0.18-4.08,2.14-11.56,4.45-5.69c2.31,5.87,7.29-10.67-6.76-8.54 c-14.05,2.13-17.61-2.67-13.69-7.64c3.9-4.99,5.51-2.68,10.67-5.17c5.16-2.49,6.59-8.54,12.81-5.87 c6.23,2.67,8.36,4.36,11.92-1.03c3.56-5.38,9.61-11.25,8.9-6.43c-0.71,4.8-8.36,10.13-1.61,10.13c6.76,0,15.71-7.29,19.43-6.23 c3.71,1.07,5.13,4.28,9.05,2.32c3.9-1.97,5.33-2.14,9.43-2.14c4.08,0,3.55,0.12,8.35-1.26c4.81-1.4,5.86,2.58,5.99,3.23 c0.54,2.82-0.74,4.32-1.22,4.98c-1.06,1.47-5,5.87-1.55,7.08c3.45,1.21,3.08,8.28-1.31,8.8c-4.39,0.52-6.28-2.58-4.73-5.86 c1.55-3.29,4.36-16.73,1.84-14.33c-2.53,2.42-8.57,6.39-8.57,5.35c0-1.03-6.56-1.21-8.8,2.42c-2.24,3.62-7.66,6.04-8.48,3.62 c-0.82-2.41-4.8,0-7.2,1.21c-2.42,1.21-6.21,4.48-7.59,2.93c-1.39-1.55-6.38-1.37-6.72,0.69c-0.34,2.08-5-5.33-7.93-1.88 c-2.94,3.44-0.87,7.58-1.21,11.2c-0.34,3.62,0.87,10.17,5.86,8.8c5-1.39,8.98,2.93,7.93,5.68c-1.03,2.76,7.42-2.24,8.46,3.45 c1.03,5.69-5.53,6.38-7.93,4.83c-2.42-1.54-4.66,3.79-2.58,5.35c2.06,1.55,3.11,7.59,0.16,12.07c-2.93,4.48-6.38,9.14-2.06,10.01 c4.3,0.87,7.07-2.93,9.13-3.79c2.08-0.85,1.09,9.65,1.21,11.89c0.18,3.07,4.95,6.06,4.95,11.23c0,5.16,0.88,9.07,3.38,9.25 c2.49,0.16,7.11,6.39,6.05,9.6c-1.07,3.2-2.74,0.71-3.23,7.66c-0.51,6.93,3.7,10.13,0,13.34c-3.71,3.2-6.74,9.61-1.58,14.77 c5.16,5.17,8.18-0.54,8.18,3.92c0,4.44,0.18,6.94,2.5,8.72c2.31,1.77-2.85,2.49-3.92,1.95c-1.07-0.52-3.2,8.02,2.13,11.04 c5.33,3.02,14.41-0.89,14.41,2.85c0,3.73,4.81,5.69,8.89,2.13c1.26-1.1,3.24-1.8,5.46-2.13c1.54-0.23,3.2-0.29,4.8-0.21 c3.45,0.22,6.61,1.17,7.71,2.69c2.32,3.2,6.23-3.19,9.43,1.51c3.2,4.72,14.05,8.8,14.05,12.9 C357.42,303.73,362.01,300.95,363.07,304.07z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 303.7754,
    y1: 152.5987,
    x2: 258.9021,
    y2: 369.2451
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M305.89,151.4c0,0-12.19-6.76-11.65,0.71c0.53,7.47,4.98,15.12,1.78,19.39c-3.2,4.27-5.09,2.85-4.68,5.87 c0.41,3.02,2.9,12.81-1.19,13.17c-4.09,0.36-9.79-2.31-8.36,1.07s9.6,7.18,10.58,4.66c0.98-2.52,1.52-4.66,4.54-8.04 c3.02-3.38-0.36-8.01,1.6-12.1c1.96-4.09,4.09-4.62,4.98-3.29c0.89,1.33-1.78-10.05,1.07-13.26c2.85-3.2,6.05,4.09,8.54,4.45 s5.52-4.09,0.89-7.65C309.36,152.82,305.89,151.4,305.89,151.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.0124,
    y1: 113.7079,
    x2: 71.139,
    y2: 330.3543
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M102.04,191.33c0,0,6.42,8.55,5.54,16.48c-0.88,7.93-0.46,12.08,0.08,15.35s-7.76,1.89-11.78-1.76 c-4.03-3.65-4.91-0.63-7.3-3.77c-2.39-3.15,0.88-6.16-1.51-7.93c-2.39-1.76-5.91-2.52-3.9-5.66c2.01-3.15,5.91-16.86,11.45-16.86 S102.04,191.33,102.04,191.33z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.3436,
    y1: 121.6473,
    x2: 109.4703,
    y2: 338.2938
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M161.99,225.88c-2.86-1.43-1.07,7.15-2.5,8.74c-1.42,1.61-8.74-5.35-10.71-4.45 c-0.55,0.25-1.39,1.5-2.42,3.29c0,0,0,0,0,0.01c-0.81,1.39-1.75,3.11-2.75,4.92c-2.36,4.32-5.14,9.23-7.69,11.77 c-4.39,4.4-1.21,10.16-1.94,15.49c-5.03,0-9.68-0.77-13.98-2.09c0.74-3.56-3.86-11.74-6.04-15.91c-2.32-4.45-8.03-6.24-12.85-6.57 c-4.83-0.33-5-6.28-3.04-8.95c1.97-2.68,7.33,1.95,16.69,3.2c9.36,1.25,3.13-22.85,0.63-37.49c-2.5-14.64,3.22-23.22,3.22-23.22 c3.38-3.95,15.34-6.59,19.81-5.69c4.47,0.89,1.79,3.38,0.18,6.42c-1.61,3.04-6.96,10.35-8.03,16.25 c-1.07,5.88,8.39,12.85,11.07,9.99c2.68-2.86,8.74,3.04,7.14,8.74c-1.61,5.72,13.57,7.15,16.97,11.07 C169.14,225.35,164.85,227.31,161.99,225.88z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.8135,
    y1: 125.6801,
    x2: 128.9402,
    y2: 342.3265
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M144.83,170.76c-2.65,4.71-3.04,10.45-0.75,15.34c0.65,1.39,1.49,2.68,2.55,3.64 c4.26,3.83,9.66,13.63,8.52,17.75c-1.14,4.12,5.54,6.53,7.67,2.41c2.13-4.12,2.65-9.52,4.17-10.08s-1.75-7.24,0.8-11.22 c2.56-3.98,0.58-19.32,15.29-31.4c3.29-2.71,10.56-15.33,5.45-13.2c-5.11,2.13-18.62,3.08-22.45,6.58s-4.68,12.31-10.79,10.61 C151.64,160.17,147.54,165.94,144.83,170.76z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.2777,
    y1: 137.5825,
    x2: 186.4044,
    y2: 354.2289
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M248.99,76.44c-0.3,4.36-3.16,14.52-6.61,10.79c-2.47-2.68-3.79-7.08-3.73-10.45 c0.67-1.13,1.4-2.34,2.17-3.62c1.39-2.28,2.98-4.76,4.99-7.34C245.4,68.99,249.25,72.51,248.99,76.44z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.9524,
    y1: 141.8647,
    x2: 207.079,
    y2: 358.5112
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M272.55,65.73c-2.41,3.81-7.2,14.49,3.15,15.54c10.37,1.03-2.5,10.19-1.86,13.35 c0.66,3.15,1.48,4.8,2.65,5.25c1.15,0.45-8.15,3.9-7.18-1.65c0.98-5.55-2.97-8.11-5.28-4.96c-2.3,3.16-12.06,11.86-9.95,5.57 c2.1-6.31,6.9-13.12,3.3-11.59c-3.6,1.53-9.75-0.25-3.6-5.97c6.16-5.72,12.91-15.63,11.86-18.63c-1.06-3.01-5.71,4.8-7.2,8.25 c-1.51,3.45-7.22,10.49-5.86,3.52c1.35-6.97-3.31-5.47,0.44-10.57c2.74-3.71,6.56-8.18,7.3-11.48c2.58-1.73,5.47-3.42,8.74-5.05 c0.47-0.23,0.93-0.47,1.42-0.7c1.51-0.74,3.12-1.46,4.78-2.14c0.7-0.29,1.4-0.58,2.13-0.85c0.71-0.29,1.46-0.56,2.2-0.84 c0.74-0.29,1.51-0.56,2.3-0.82c0.78-0.27,1.58-0.54,2.39-0.8c0.96,1.91,2.35,3.46-0.63,6.32c0,0-4.95,9.49-7.51,8.26 C273.61,54.53,274.96,61.94,272.55,65.73z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 360.3383,
    y1: 164.3144,
    x2: 315.465,
    y2: 380.9608
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M356.03,208.42c-2.41,3.81-7.2,14.49,3.15,15.54c10.37,1.03-2.5,10.19-1.86,13.35 c0.66,3.15,1.48,4.8,2.65,5.25c1.15,0.45-8.15,3.9-7.18-1.65c0.98-5.55-2.97-8.11-5.28-4.96c-2.3,3.16-12.06,11.86-9.95,5.57 c2.1-6.31,6.9-13.12,3.3-11.59c-3.6,1.53-9.75-0.25-3.6-5.97c6.16-5.72,12.91-15.63,11.86-18.63c-1.06-3.01-5.71,4.8-7.2,8.25 c-1.51,3.45-7.22,10.49-5.86,3.52c1.35-6.97-3.31-5.47,0.44-10.57c1.95-2.65,4.46-5.69,6.01-8.41c1.49-2.63,3.76-4.72,6.4-6.2 c1.58-0.89,3.27-1.76,5.05-2.62c1.51-0.74,3.12-1.46,4.78-2.14c1.7-0.71,3.48-1.4,5.35-2.07c3.05-1.09,5.46,2.74,3.13,4.99 l-0.09,0.09c0,0-4.95,9.49-7.51,8.26C357.09,197.21,358.44,204.62,356.03,208.42z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 262.8357,
    y1: 144.119,
    x2: 217.9624,
    y2: 360.7654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M282.88,58.69c0.08-1.45-1.51-2.38-2.73-1.59c-1.22,0.79-2.47,1.86-2.43,2.88c0.08,1.98,0.24,6.35-0.87,6.82 c-1.11,0.48,4.44,0.71,5.55-4.76C282.69,60.64,282.83,59.54,282.88,58.69z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.3723,
    y1: 138.2234,
    x2: 189.499,
    y2: 354.8699
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M214.89,204.09c0.51-1.3,1.47-2.41,2.75-2.96c1.17-0.51,2.47-0.51,3.01,1.52 c1.07,4.04,1.69,10.33,2.91,10.33s1.23,7.2,0,12.11s-3.07,3.76-5.82-2.95s-7.36-7.45-5.21-12.37 C213.68,207.11,214.44,205.25,214.89,204.09z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.0305,
    y1: 134.8386,
    x2: 173.1572,
    y2: 351.485
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M248.22,97.93c0,2.17-0.88,4.37-4.43,4.45c-7.11,0.15-7.26,1.39-8.96,3.24c-1.69,1.84-7.56-7.11-10.49-3.4 c-2.93,3.7-5.87,4.62-5.55,7.86c0.3,3.24,0.15,6.68-0.77,8.43c-0.93,1.76,0,4.54,0,10.1c0,5.55-3.86,9.72-3.71,13.73 c0.15,4.01-7.86,8.84-8.95,4.73c-1.09-4.11-6.94-7.97-8.03-6.28c-1.07,1.7-4.63,2.79-2.31-3.4c2.31-6.17,7.25-6.63,5.4-14.34 c-0.58-2.42-0.56-5.2-0.11-7.85c0,0,0-0.01,0.01-0.01c1.33-2.05,2.76-4.43,4.32-6.96c0.92-1.51,1.9-3.07,2.93-4.63 c3.18-4.85,6.82-9.75,11.04-13.32c1.43-1.18,2.91-2.24,4.48-3.08c0.45-0.25,0.91-0.48,1.37-0.69c0.06-0.01,0.1-0.04,0.14-0.05 c0.26-0.12,0.52-0.23,0.78-0.33l0.78-0.29c0.26-0.08,0.51-0.16,0.76-0.23c0.16-0.05,0.33-0.1,0.48-0.14 c0.21-0.06,0.43-0.11,0.65-0.15c0.25-0.05,0.49-0.11,0.74-0.15c-2.13,3.52-4.67,6.27,2.8,6.19c7.82-0.08,8.85-2.12,12.85,0.21 C246.7,92.88,248.22,95.3,248.22,97.93z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 340.0922,
    y1: 160.1209,
    x2: 295.2189,
    y2: 376.7673
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M360.34,178.05c0,1.48-0.88,2.98-4.43,3.04c-7.11,0.1-7.26,0.95-8.96,2.21c-1.69,1.26-7.56-4.84-10.49-2.31 c-2.93,2.52-5.87,3.15-5.55,5.36c0.3,2.21,0.15,4.55-0.77,5.74c-0.93,1.2,0,3.09,0,6.89c0,3.79-3.86,6.62-3.71,9.36 c0.15,2.74-7.86,6.02-8.95,3.22c-1.09-2.8-6.94-5.43-8.03-4.28c-1.07,1.16-4.63,1.9-2.31-2.31c2.31-4.21,7.25-4.52,5.4-9.77 c-0.58-1.65-0.56-3.54-0.11-5.35c3.97-12.51,21.21-18.51,22.78-19.08c1.8-0.67,3.7-1.15,5.71-1.39c-2.13,2.4-4.67,4.27,2.8,4.22 c7.82-0.06,8.85-1.44,12.85,0.14C358.82,174.61,360.34,176.26,360.34,178.05z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.8969,
    y1: 139.9891,
    x2: 198.0235,
    y2: 356.6355
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M220.54,252.28c-0.71-1.59-2.87-1.86-3.92-0.48c-1.03,1.35-1.86,2.97-1.63,4.51 c0.54,3.68,6.81,6.27,7.36,2.45C222.65,256.61,221.43,254.27,220.54,252.28z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 360.955,
    y1: 164.4421,
    x2: 316.0816,
    y2: 381.0885
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M340.39,254.27c-1.2-0.62-4.52,0.12-4.05,3.57c0.48,3.45,6.67,16.19,8.45,10.95 C346.58,263.55,343.76,256.02,340.39,254.27z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: 372.4148,
    y1: 166.8158,
    x2: 327.5415,
    y2: 383.4622
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    style: {
      stopColor: "#37363B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78"
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M353.91,268.54c1.36-2.58-2.51-4.71-4.11-2.27c-1.18,1.8-2.39,4.23-2.13,6.4c0.48,4.05,0.25,7.97-2.31,9.52 c-2.57,1.55,5.77,9.4,6.48,0.48c0.71-8.93-1.55-9.98,0.83-12.43C353.17,269.72,353.59,269.13,353.91,268.54z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 264.794,
    y1: 265.2423,
    x2: 291.1686,
    y2: 138.0239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M306.95,70.02c-1.77,1.28-3.79,1.5-4.51,0.5c-0.72-1,0.13-2.84,1.9-4.12c1.77-1.28,3.79-1.5,4.51-0.5 S308.72,68.74,306.95,70.02z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.0687,
    y1: 265.5065,
    x2: 292.4432,
    y2: 138.2881
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M307.43,81.58c-1.66,2.88-4.3,4.46-5.89,3.54c-1.59-0.92-1.54-4,0.13-6.87s4.3-4.46,5.89-3.54 C309.14,75.63,309.09,78.71,307.43,81.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.2148,
    y1: 267.1954,
    x2: 300.5894,
    y2: 139.977
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M314.71,88.2c-0.76,2.51-2.8,4.12-4.56,3.58s-2.57-3-1.81-5.51c0.76-2.51,2.8-4.12,4.56-3.58 C314.66,83.22,315.47,85.69,314.71,88.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.0297,
    y1: 270.4741,
    x2: 316.4042,
    y2: 143.2556
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M321.5,132.92c-1.74,1.96-4.27,2.57-5.64,1.35c-1.38-1.22-1.08-3.8,0.66-5.76c1.74-1.96,4.27-2.57,5.64-1.35 C323.53,128.38,323.24,130.96,321.5,132.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: 317.3743,
    y1: 276.1431,
    x2: 343.7488,
    y2: 148.9246
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M343.72,163.3c-1.74,1.96-4.27,2.57-5.64,1.35c-1.38-1.22-1.08-3.8,0.66-5.76c1.74-1.96,4.27-2.57,5.64-1.35 C345.75,158.76,345.46,161.34,343.72,163.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_86_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.2203,
    y1: 276.9404,
    x2: 347.5949,
    y2: 149.722
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M341.63,192.7c-1.74,1.96-4.27,2.57-5.64,1.35s-1.08-3.8,0.66-5.76c1.74-1.96,4.27-2.57,5.64-1.35 C343.67,188.16,343.37,190.74,341.63,192.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 357.0329,
    y1: 284.365,
    x2: 383.4075,
    y2: 157.1466
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M377.58,199.5c-1.74,1.96-4.27,2.57-5.64,1.35c-1.38-1.22-1.08-3.8,0.66-5.76c1.74-1.96,4.27-2.57,5.64-1.35 C379.61,194.96,379.32,197.54,377.58,199.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: 361.9835,
    y1: 178.0584,
    x2: 388.358,
    y2: 50.8399,
    gradientTransform: "matrix(0.956 -0.2933 0.2933 0.956 -27.0251 219.9246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M367.38,211.49c-1.09,2.39-3.33,3.71-5,2.95c-1.67-0.76-2.15-3.32-1.06-5.7c1.09-2.39,3.33-3.71,5-2.95 C368,206.54,368.47,209.1,367.38,211.49z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: 302.2762,
    y1: 273.013,
    x2: 328.6508,
    y2: 145.7946
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M328.51,162.48c-0.93,2.04-3.04,3.07-4.71,2.31s-2.28-3.03-1.35-5.07s3.04-3.07,4.71-2.31 C328.83,158.17,329.43,160.44,328.51,162.48z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.0176,
    y1: 270.0569,
    x2: 314.3922,
    y2: 142.8385
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M308.72,186.19c-0.93,2.04-3.04,3.07-4.71,2.31c-1.67-0.76-2.28-3.03-1.35-5.07s3.04-3.07,4.71-2.31 S309.65,184.16,308.72,186.19z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: 532.5876,
    y1: -35.0455,
    x2: 558.9622,
    y2: -162.2639,
    gradientTransform: "matrix(0.222 -1.0192 1.1125 0.432 338.6322 793.594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M316.26,170.54c2.06,1.83,2.74,4.42,1.52,5.8s-3.88,1.01-5.94-0.81c-2.06-1.83-2.74-4.42-1.52-5.8 C311.54,168.35,314.2,168.72,316.26,170.54z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_92_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.8391,
    y1: 270.2272,
    x2: 315.2137,
    y2: 143.0088
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M315.4,150.25c-2.5,0.81-4.98,0.05-5.55-1.69c-0.57-1.75,0.99-3.82,3.49-4.64s4.98-0.05,5.55,1.69 C319.46,147.37,317.89,149.44,315.4,150.25z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.8335,
    y1: 269.8115,
    x2: 313.2081,
    y2: 142.593
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M328.04,87.05c-1.75,1.96-5.44,2.74-6.56,1.74c-1.12-1-0.61-3.39,1.14-5.35c1.75-1.96,4.07-2.74,5.19-1.74 S329.79,85.09,328.04,87.05z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_94_",
    gradientUnits: "userSpaceOnUse",
    x1: 365.2852,
    y1: 286.0758,
    x2: 391.6598,
    y2: 158.8574
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M404.01,93.32c-1.9-1.81-2.56-5.53-1.53-6.61c1.03-1.08,3.41-0.5,5.31,1.31s2.61,4.15,1.58,5.24 C408.34,94.35,405.92,95.13,404.01,93.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_95_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.8763,
    y1: 287.235,
    x2: 397.2509,
    y2: 160.0165
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M411.86,83.6c-1.9-1.81-2.56-5.53-1.53-6.61c1.03-1.08,3.41-0.5,5.31,1.31s2.61,4.15,1.58,5.24 C416.19,84.62,413.76,85.4,411.86,83.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_96_",
    gradientUnits: "userSpaceOnUse",
    x1: 373.435,
    y1: 287.7654,
    x2: 399.8096,
    y2: 160.547
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M398.29,151.63c1.4-2.22,4.91-3.61,6.18-2.81c1.27,0.8,1.16,3.24-0.24,5.47c-1.4,2.22-3.56,3.38-4.82,2.58 C398.14,156.07,396.89,153.85,398.29,151.63z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_97_",
    gradientUnits: "userSpaceOnUse",
    x1: 270.9979,
    y1: 266.5284,
    x2: 297.3725,
    y2: 139.31
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M303.99,122.49c1.12-2.37,0.4-6.08-0.96-6.72c-1.35-0.64-3.36,0.76-4.48,3.14s-0.93,4.82,0.42,5.46 C300.33,125,302.87,124.86,303.99,122.49z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_98_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.3384,
    y1: 265.5625,
    x2: 292.713,
    y2: 138.344
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M286.33,184.25c1-2.12,0.14-5.54-1.21-6.18c-1.35-0.64-3.26,0.56-4.27,2.69c-1,2.12-0.72,4.37,0.63,5.01 C282.84,186.4,285.33,186.38,286.33,184.25z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_99_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.2023,
    y1: 275.2781,
    x2: 339.5769,
    y2: 148.0597
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M325.92,229.06c1-2.12,0.14-5.54-1.21-6.18c-1.35-0.64-3.26,0.56-4.27,2.69c-1,2.12-0.72,4.37,0.63,5.01 C322.43,231.21,324.92,231.18,325.92,229.06z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_100_",
    gradientUnits: "userSpaceOnUse",
    x1: 324.7003,
    y1: 277.6619,
    x2: 351.0749,
    y2: 150.4435
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M333.53,250.15c1.16-2.44,0.47-6.23-0.88-6.87s-3.39,0.82-4.54,3.27s-1,4.94,0.36,5.58 C329.82,252.77,332.38,252.6,333.53,250.15z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_101_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.06,
    y1: 280.0169,
    x2: 362.4345,
    y2: 152.7985
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M338.07,279.85c2.28-1.46,3.71-5.03,2.91-6.29c-0.81-1.26-3.31-1.1-5.58,0.35 c-2.28,1.46-3.47,3.66-2.66,4.92C333.53,280.09,335.79,281.3,338.07,279.85z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_102_",
    gradientUnits: "userSpaceOnUse",
    x1: 359.0447,
    y1: 284.782,
    x2: 385.4192,
    y2: 157.5636
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M359.79,290.71c2.28-1.46,3.71-5.03,2.91-6.29c-0.81-1.26-3.31-1.1-5.58,0.35s-3.47,3.66-2.66,4.92 C355.25,290.96,357.51,292.17,359.79,290.71z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_103_",
    gradientUnits: "userSpaceOnUse",
    x1: 316.2905,
    y1: 275.9184,
    x2: 342.665,
    y2: 148.7
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M313.59,277.27c-1.16-2.44-0.47-6.23,0.88-6.87c1.35-0.64,3.39,0.82,4.54,3.27c1.16,2.44,1,4.94-0.36,5.58 C317.31,279.88,314.75,279.71,313.59,277.27z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_104_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.3989,
    y1: 264.3311,
    x2: 286.7735,
    y2: 137.1127
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M292.33,125.41c1.12-2.37,0.4-6.08-0.96-6.72c-1.35-0.64-3.36,0.76-4.48,3.14 c-1.12,2.37-0.93,4.82,0.42,5.46C288.67,127.92,291.21,127.78,292.33,125.41z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_105_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.5449,
    y1: 261.8736,
    x2: 274.9195,
    y2: 134.6551
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M285.17,98.51c1.71-1.99,1.99-5.76,0.85-6.73c-1.14-0.97-3.44-0.15-5.15,1.84 c-1.71,1.99-2.17,4.4-1.04,5.37C280.97,99.97,283.46,100.51,285.17,98.51z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_106_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.9494,
    y1: 253.4574,
    x2: 234.324,
    y2: 126.239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M229.78,134.01c1.38,2.1,4.77,3.35,5.96,2.56s1.05-3.12-0.33-5.22c-1.38-2.1-3.47-3.16-4.66-2.37 C229.55,129.76,228.4,131.91,229.78,134.01z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_107_",
    gradientUnits: "userSpaceOnUse",
    x1: 166.3787,
    y1: 244.8391,
    x2: 192.7533,
    y2: 117.6207
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M193.08,129.38c1.49-2.02,1.49-5.64,0.33-6.48c-1.15-0.85-3.29,0.1-4.78,2.13c-1.49,2.02-1.76,4.35-0.6,5.2 C189.18,131.07,191.59,131.4,193.08,129.38z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_108_",
    gradientUnits: "userSpaceOnUse",
    x1: 240.5134,
    y1: 260.2085,
    x2: 266.8879,
    y2: 132.9901
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M281.42,76.18c1.71-1.99,1.99-5.76,0.85-6.73c-1.14-0.97-3.44-0.15-5.15,1.84 c-1.71,1.99-2.17,4.4-1.04,5.37C277.22,77.63,279.71,78.17,281.42,76.18z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_109_",
    gradientUnits: "userSpaceOnUse",
    x1: 243.981,
    y1: 260.9274,
    x2: 270.3555,
    y2: 133.709
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M289.72,52.14c-1.52,1.31-4.4,1.52-5.14,0.65c-0.74-0.87-0.11-2.63,1.41-3.93s3.36-1.66,4.1-0.79 C290.84,48.94,291.25,50.84,289.72,52.14z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_110_",
    gradientUnits: "userSpaceOnUse",
    x1: 249.2773,
    y1: 262.0254,
    x2: 275.6519,
    y2: 134.807
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M280.02,128.87c1.12-2.37,0.4-6.08-0.96-6.72c-1.35-0.64-3.36,0.76-4.48,3.14 c-1.12,2.37-0.93,4.82,0.42,5.46C276.35,131.38,278.89,131.24,280.02,128.87z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_111_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.492,
    y1: 244.0333,
    x2: 188.8666,
    y2: 116.8149
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M171.19,214.96c-0.76-2.51-3.28-4.93-4.37-4.6c-1.09,0.33-1.35,2.64-0.59,5.15 c0.76,2.51,2.26,4.28,3.35,3.95C170.67,219.13,171.95,217.47,171.19,214.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_112_",
    gradientUnits: "userSpaceOnUse",
    x1: 166.0896,
    y1: 244.7792,
    x2: 192.4642,
    y2: 117.5608
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M170.86,233.56c0.7-2.08-0.09-5.04-1.17-5.41c-1.08-0.36-2.52,1.03-3.23,3.11c-0.7,2.08-0.4,4.07,0.68,4.43 C168.22,236.06,170.16,235.64,170.86,233.56z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_113_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.3186,
    y1: 236.9486,
    x2: 154.6932,
    y2: 109.7302
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "M140.43,191.19c-0.18-2.62-2.08-5.54-3.22-5.46c-1.14,0.08-1.91,2.26-1.73,4.88s1.24,4.68,2.38,4.6 C138.99,195.14,140.61,193.81,140.43,191.19z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_114_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.1933,
    y1: 259.5202,
    x2: 263.5678,
    y2: 132.3018
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st122",
    d: "M266.85,131.57c1.12-2.37,0.4-6.08-0.96-6.72c-1.35-0.64-3.36,0.76-4.48,3.14s-0.93,4.82,0.42,5.46 C263.19,134.08,265.73,133.94,266.85,131.57z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_115_",
    gradientUnits: "userSpaceOnUse",
    x1: 287.5021,
    y1: 269.9501,
    x2: 313.8767,
    y2: 142.7316
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "M341.02,43.72c0,0,3.67-5.96,3.67,0s-5.27,7.1-7.79,8.48c-2.52,1.37-4.58,6.87-3.9,8.71s0.88,3.67-2.2,4.35 c-3.07,0.69-9.71,9.39-9.37,12.83c0.34,3.44-4.7,5.04-4.7,1.15c0-3.9,2.29-2.75,3.67-8.94c1.37-6.19-0.59-5.88,4.63-9.01 c5.22-3.13,4.53-6.34,2.93-6.34c-1.6,0-1.15-2.52,0.92-3.44S341.02,43.72,341.02,43.72z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_116_",
    gradientUnits: "userSpaceOnUse",
    x1: 376.0681,
    y1: 288.3113,
    x2: 402.4427,
    y2: 161.0929
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M420.38,93.01c-0.39-0.29-8.84-6.82-8.24-2.03c0.6,4.79,5.99,3.9,2.87,6.5c-3.13,2.6-13.45,4.42-6.94,7.67 c6.51,3.25,7.99,2.24,10.33-1.82c2.34-4.06,2.69-4.14,4.92-4.51S422.08,94.29,420.38,93.01z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_117_",
    gradientUnits: "userSpaceOnUse",
    x1: 396.1361,
    y1: 292.4717,
    x2: 422.5106,
    y2: 165.2533
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M444,98.96c0.29,0.39,1.81,11.58-2.98,10.98c-4.79-0.6-3.9-5.99-6.5-2.87c-2.6,3.13-4.42,13.45-7.67,6.94 c-3.25-6.51-2.24-7.99,1.82-10.33c4.06-2.34,4.14-2.69,4.51-4.92C433.55,96.54,440.58,94.29,444,98.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_118_",
    gradientUnits: "userSpaceOnUse",
    x1: 1058.4401,
    y1: 146.6168,
    x2: 1084.8146,
    y2: 19.3984,
    gradientTransform: "matrix(-0.9631 -0.269 0.269 -0.9631 1355.3684 654.1722)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M351.42,258.1c-0.17-0.46,1.37-11.64,5.83-9.77c4.45,1.86,2.14,6.82,5.49,4.51 c3.34-2.31,7.88-11.77,9.26-4.62c1.38,7.15,0,8.3-4.53,9.46c-4.54,1.16-4.71,1.48-5.67,3.52 C360.83,263.24,353.46,263.51,351.42,258.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_119_",
    gradientUnits: "userSpaceOnUse",
    x1: 356.2828,
    y1: 284.2095,
    x2: 382.6574,
    y2: 156.991
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M458.18,156.44c-13.09,10.49-33.06,13.8-35.54,42.91h-0.04c-5.16,0.45-10.38,1.17-15.4,2.05 c-31.23-4.75-38.34-20.14-39.87-23.45c-2.36-5.11-0.29-13.05-1.37-17.2c-1.09-4.17-4.89-3.26-7.8-3.26 c-2.89,0-2.53,2.71-0.18,5.79c2.35,3.08-0.71,4.88-3.79,3.99c-3.08-0.91-2.35-7.6-3.08-12.32c-0.73-4.7-4.17,0-7.6-0.91 c-3.44-0.89,0-2.71,1.18-4.7c1.18-1.99,0.63-4.34,0-9.95c-0.63-5.61,1.53-8.87,3.16-11.23c1.62-2.35,11.4-5.43,12.85-11.4 c1.44-5.98-3.81-2.72-6.7-0.37c-2.9,2.36-4.34,3.99-4.34-6.7s7.05-8.14,7.23-3.79c0.18,4.34,4.52-2.36,3.63-4.34 c-0.91-1.99,2.53-8.88,3.44-12.32c0.91-3.44-5.8-0.54-10.15,2.17c-4.34,2.72-4.15,6.89-6.32,9.42c-2.17,2.53-1.09-2.9-4.89,2.9 c-3.81,5.79-1.99,18.82-1.37,26.42c0.62,7.6-0.62,7.97-4.96,8.33c-4.34,0.36-1.44,4.34-1.21,11.77c0.25,7.42-2.41,6.87-6.02,3.62 c-3.6-3.26,1.07-7.05,0-6.7c-1.06,0.36-4.72,1.62-5.98-3.08c-1.26-4.7,4.34-4.7,6.87-4.88c2.54-0.19,1.81-6.34,0.78-12.32 c-1.03-5.97,2.12-8.51,4.34-11.59c2.24-3.07,0.67-7.78-3.31-6.52c-3.99,1.28-5.43,7.42-8.87,10.68 c-3.45,3.26-1.46-4.88,2.09-10.68c3.55-5.79,0.8-4.7-4.07-6.7c-4.88-1.99,0.89-3.79,4.07-8.14c3.19-4.34,6.6,1.44,8.62,4.34 c2.03,2.89,2.32-0.91,3.23-3.99c0.89-3.08,1.98-2.72,5.24-2.72c3.27,0,8.03-5.62,7.55-11.7c-0.52-6.38-1.75-0.96-4.1-7.3 c-2.36-6.34,4.81-7,5.61-6.82c5.14,1.21,4.08,9.6,4.65,15.76c0.58,6.15,5.11-1.04,6.39-2.39c1.28-1.35,6.26-2.64,4.83,3.05 c-1.42,5.68,4.69,5.54,6.82,3.97c2.13-1.57,7.96-1.99,6.82,1.09c-1.13,3.08,5.27,4.32,8.66,0.92c3.41-3.38,6.97,2.97,6.26,6.52 c-0.71,3.55,0,5.97,2.69,2.85c2.71-3.13,5.54,3.82,4.84,8.37c-0.71,4.55,7.66,9.94,13.91,3.55c6.26-6.39,4.12,6.39,4.12,10.23 c0,3.84,6.96,3.27,8.66,1c1.7-2.28,3.7,10.64,0.99,15.76c-2.69,5.11,1.28,7.11,0.43,13.21c-0.85,6.1-9.23-4.4-10.79-8.52 c-1.57-4.11-7.67-3.12-9.38,0.58c-1.7,3.68-4.11-0.15-3.26-3.27c0.85-3.12-1.7-2.69-6.26,1.28c-4.55,3.97-4.12,4.98-7.11,0.85 s-4.69,0.14-4.96,3.12c-0.29,2.98,3.97,10.09,2.69,15.34c-1.28,5.25,0.99,6.1,4.4,2.85c3.41-3.27,8.39,3.12,13.21,6.1 c4.83,2.98,0.29-4.4-0.14-9.8c-0.43-5.4,4.96-4.83,7.52-2.27c2.56,2.56,1.14,6.82,4.98,9.38c3.84,2.56,5.97-5.11,8.81-7.53 c2.83-2.42,3.26,2.42,1.42,6.68c-1.84,4.25,6.1,0.85,6.39-1.28c0.27-2.13,3.26-7.11,3.26-2.71c0,4.41,3.45,2.67,3.45,2.67 c9.6-4.17,6.34-6.89,8.33-8.33C454.6,154.15,456.43,154.97,458.18,156.44z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_120_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.9106,
    y1: 283.0957,
    x2: 377.2852,
    y2: 155.8773
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M392.8,70.65c0,0-8.13-3.55-9.17,1.15c-1.03,4.7,1.37,8.48,4.58,6.3c3.21-2.18,2.98,0,7.68,2.41 s6.64,4.58,7.22,1.49c0.57-3.09,1.26-5.38,2.18-7.79C406.2,71.79,397.84,67.78,392.8,70.65z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_121_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.4686,
    y1: 263.1017,
    x2: 280.8431,
    y2: 135.8832
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M294.53,56.83c0,0-3.89,7.65-1.15,8.94c2.74,1.29,3.02,4.89,1.73,6.91c-1.3,2.02-0.53,4.22,0.74,3.77 c1.27-0.46,1.46,3.58,0,5.59c-1.46,2.02,0.78,8.93,1.03,11.23c0.24,2.3,5.43,4.75,1.97,6.19c-3.46,1.44-5.55,3.46-6.45-1.01 c-0.9-4.46,2.56-8.5-2.48-8.64s-4.61,0.72-2.3-5.33s4.18-10.01,1.87-8.82c-2.3,1.19-4.9,2.2-2.74-2.7s2.3-7.53-0.14-7.22 c-2.45,0.31-3.46-6.46,2.59-8.91S294.53,56.83,294.53,56.83z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_122_",
    gradientUnits: "userSpaceOnUse",
    x1: 265.3961,
    y1: 265.3671,
    x2: 291.7706,
    y2: 138.1487
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M304.54,127.06c2.47,2.14-3.9,9.38,0,13.09s-1.76,2.73-3.32,0s-13.48-1.97-14.26,2.43 c-0.78,4.41,0,7.53,2.54,13.98c2.54,6.45,3.39,9.18,2.87,12.31c-0.52,3.13-3.06,5.27-4.23,3.32c-1.17-1.95-3.13-9.77-5.18-4.88 c-2.05,4.88-6.15,11.72-4.98,3.52c1.17-8.2,1.56-7.42,2.54-11.33c0.98-3.91,1.76-5.17,0.2-8.64s2.93-6.99-1.95-9.92 s0.59-5.28,2.54-6.45c1.95-1.17,2.93,0,6.84,0S301.14,124.11,304.54,127.06z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_123_",
    gradientUnits: "userSpaceOnUse",
    x1: 303.1701,
    y1: 273.1983,
    x2: 329.5446,
    y2: 145.9799
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M302.56,203.22c0,0-5.04,3.04-2.52,8.6s1.32,5.79,2.52,9.39c1.2,3.6,3.6,0.24,4.79,0 c1.2-0.24,0.72,0.24,2.16,4.31s0,10.31,2.16,11.98c2.16,1.68,2.84-2.16,6.1-0.96s2.29,6.23,2.29,8.39c0,2.16,0.72,7.91,2.64,8.63 c1.92,0.72,4.07-1.44,5.03,2.64s3.36,10.07,2.64,12.22c-0.72,2.16-2.4,2.64-1.2,6.47c1.2,3.84-2.88,0.96-2.88,6.95 s-4.55,3.6-4.55,3.6s-1.2-1.68,0.72-4.79c1.92-3.12,4.07-10.07,1.68-15.1c-2.4-5.03-5.55-12.46-6.37-7.91 c-0.82,4.55-5.62,2.64-5.86-0.24c-0.24-2.88-6.95-8.87-9.11-2.88c-2.16,5.99,5.03,11.03,5.99,13.66c0.96,2.64-1.48,8.87-2.9,4.55 s-3.55-9.83-6.56-12.46c-3.01-2.64-7.95-5.99-8-11.03s2.11-10.55,3.31-13.18c1.2-2.64-2.64-4.07-0.72-13.9 c1.92-9.83,3.84-11.27,0-14.38c-3.84-3.12-3.6-5.95-1.56-6.93s2.52-4.81,7.67-4.57C305.19,196.52,302.56,203.22,302.56,203.22z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_124_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.1997,
    y1: 263.4605,
    x2: 282.5743,
    y2: 136.2421
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M363.07,304.07c-0.16-0.06-0.33-0.11-0.49-0.16c-3.41-1.17-5.99-2.52-8.63-3.78 c-1.57-0.74-3.16-1.46-4.96-2.06c-3.95-1.37-8.96-2.27-16.99-2.02c-1.75,0.04-3.63,0.15-5.69,0.32 c-5.69,0.47-12.65,1.39-21.31,2.91c-1.9,0.34-3.88,0.69-5.95,1.1c-0.11,0.01-0.23,0.04-0.34,0.05c-7.55,1.43-14.53,2.1-20.99,2.12 c-2.12,0-4.17-0.07-6.17-0.19c-3.6-0.22-7.03-0.65-10.28-1.25c-1.31-0.74-2.36-1.54-3.08-2.41c-5.17-6.23-12.81-21.89-19.4-23.32 c-6.5-1.4-18.86,0.32-22.27-1.35c-0.99-1.28-1.92-2.53-2.78-3.78c-0.21-0.3-0.41-0.59-0.62-0.89v-0.01 c-0.29-1.33-0.25-2.72,0.05-3.92c0.71-2.85,11.03,8.72,14.41-0.18c3.38-8.9-2.13-11.74-2.67-16.55 c-0.54-4.8,4.26-15.65,4.44-22.95c0.18-7.3-0.18-18.37-1.42-22.52c-1.25-4.17-6.05-1.5-6.59-5.6c-0.54-4.08-17.1-2.78-14.77,14.19 c1.21,8.74,6.5,10.24,9.14,14.7c2.64,4.47,1,5.09-1.22,18.68c-1.22,7.42-4.07,12.07-6.72,15.18c-0.93-1.8-1.69-3.45-2.34-4.92 c-1.68-3.89-2.36-6.37-2.36-6.37s-10.42,2.76-21.2,6.37c-9.03,3.01-18.3,6.61-21.93,9.66c-2.87,2.42-5.38,4.98-7.58,7.6 c-3.96-0.52-6.86-1.35-8.77-2.19c0.8-1.32,1.57-2.6,2.32-3.82c0.3-0.49,0.6-0.98,0.91-1.46l0.01-0.01 c0.29-0.48,0.6-0.95,0.89-1.42c-1.42,0.37-2.82,0.67-4.19,0.93c-0.45-1.62-1.4-3.85-1.5-6.38c-0.1-2.38,4.65-6.2,10.12-9.82 c1.31-0.88,2.67-1.75,4.01-2.57c0.51-0.32,1.02-0.62,1.51-0.92c1.46-0.88,2.87-1.72,4.18-2.46c2.61-1.51,4.73-2.69,5.75-3.3 c4.06-2.45,5.68-2.85,6.09,1.77c0.4,4.63,4.66,5.32,4.66,0c0-5.31,0.41-11.31-3.04-15.99c-3.45-4.66,3.04-14.61-2.85-19.27 c-5.88-4.67,0.21-8.13,4.67-5.88c4.45,2.23-0.21-2.64-2.03-7.11c-1.83-4.47,4.06-4.67,3.66-8.94c-0.41-4.26,5.88-17.05,8.73-23.87 c2.83-6.82,5.27-2.72,8.72-9.44c3.45-6.72,3.86,2.25,6.41,5.1c2.53,2.85-0.11,6.09,1.11,6.3c1.21,0.21,10.15-13.2,12.79-9.95 c2.64,3.26-3.45,6.3-5.88,9.35c-1.14,1.42-1.22,3.79-0.98,5.94c0.95-0.99,2.01-1.83,3.49-3.3c4.26-4.28,13.69-3.92,11.2-10.32 c-2.49-6.41-4.62-8.18-4.62-10.49s3.2-12.99,5.16-9.97c1.95,3.02,5.69,5.69,5.87,12.1c0.18,6.41,2.13,13.87,6.41,9.43 c4.26-4.45,1.24-11.92,1.42-16.02c0.18-4.08,2.14-11.56,4.45-5.69c2.31,5.87,7.29-10.67-6.76-8.54 c-14.05,2.13-17.61-2.67-13.69-7.64c3.9-4.99,5.51-2.68,10.67-5.17c5.16-2.49,6.59-8.54,12.81-5.87 c6.23,2.67,8.36,4.36,11.92-1.03c3.56-5.38,9.61-11.25,8.9-6.43c-0.71,4.8-8.36,10.13-1.61,10.13c6.76,0,15.71-7.29,19.43-6.23 c3.71,1.07,5.13,4.28,9.05,2.32c3.9-1.97,5.33-2.14,9.43-2.14c4.08,0,3.55,0.12,8.35-1.26c4.81-1.4,5.86,2.58,5.99,3.23 c0.54,2.82-0.74,4.32-1.22,4.98c-1.06,1.47-5,5.87-1.55,7.08c3.45,1.21,3.08,8.28-1.31,8.8c-4.39,0.52-6.28-2.58-4.73-5.86 c1.55-3.29,4.36-16.73,1.84-14.33c-2.53,2.42-8.57,6.39-8.57,5.35c0-1.03-6.56-1.21-8.8,2.42c-2.24,3.62-7.66,6.04-8.48,3.62 c-0.82-2.41-4.8,0-7.2,1.21c-2.42,1.21-6.21,4.48-7.59,2.93c-1.39-1.55-6.38-1.37-6.72,0.69c-0.34,2.08-5-5.33-7.93-1.88 c-2.94,3.44-0.87,7.58-1.21,11.2c-0.34,3.62,0.87,10.17,5.86,8.8c5-1.39,8.98,2.93,7.93,5.68c-1.03,2.76,7.42-2.24,8.46,3.45 c1.03,5.69-5.53,6.38-7.93,4.83c-2.42-1.54-4.66,3.79-2.58,5.35c2.06,1.55,3.11,7.59,0.16,12.07c-2.93,4.48-6.38,9.14-2.06,10.01 c4.3,0.87,7.07-2.93,9.13-3.79c2.08-0.85,1.09,9.65,1.21,11.89c0.18,3.07,4.95,6.06,4.95,11.23c0,5.16,0.88,9.07,3.38,9.25 c2.49,0.16,7.11,6.39,6.05,9.6c-1.07,3.2-2.74,0.71-3.23,7.66c-0.51,6.93,3.7,10.13,0,13.34c-3.71,3.2-6.74,9.61-1.58,14.77 c5.16,5.17,8.18-0.54,8.18,3.92c0,4.44,0.18,6.94,2.5,8.72c2.31,1.77-2.85,2.49-3.92,1.95c-1.07-0.52-3.2,8.02,2.13,11.04 c5.33,3.02,14.41-0.89,14.41,2.85c0,3.73,4.81,5.69,8.89,2.13c1.26-1.1,3.24-1.8,5.46-2.13c1.54-0.23,3.2-0.29,4.8-0.21 c3.45,0.22,6.61,1.17,7.71,2.69c2.32,3.2,6.23-3.19,9.43,1.51c3.2,4.72,14.05,8.8,14.05,12.9 C357.42,303.73,362.01,300.95,363.07,304.07z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_125_",
    gradientUnits: "userSpaceOnUse",
    x1: 279.7827,
    y1: 268.3497,
    x2: 306.1572,
    y2: 141.1313
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M305.89,151.4c0,0-12.19-6.76-11.65,0.71c0.53,7.47,4.98,15.12,1.78,19.39c-3.2,4.27-5.09,2.85-4.68,5.87 c0.41,3.02,2.9,12.81-1.19,13.17c-4.09,0.36-9.79-2.31-8.36,1.07s9.6,7.18,10.58,4.66c0.98-2.52,1.52-4.66,4.54-8.04 c3.02-3.38-0.36-8.01,1.6-12.1c1.96-4.09,4.09-4.62,4.98-3.29c0.89,1.33-1.78-10.05,1.07-13.26c2.85-3.2,6.05,4.09,8.54,4.45 s5.52-4.09,0.89-7.65C309.36,152.82,305.89,151.4,305.89,151.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_126_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.0409,
    y1: 229.4276,
    x2: 118.4154,
    y2: 102.2092
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M102.04,191.33c0,0,6.42,8.55,5.54,16.48c-0.88,7.93-0.46,12.08,0.08,15.35s-7.76,1.89-11.78-1.76 c-4.03-3.65-4.91-0.63-7.3-3.77c-2.39-3.15,0.88-6.16-1.51-7.93c-2.39-1.76-5.91-2.52-3.9-5.66c2.01-3.15,5.91-16.86,11.45-16.86 S102.04,191.33,102.04,191.33z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_127_",
    gradientUnits: "userSpaceOnUse",
    x1: 130.3719,
    y1: 237.3743,
    x2: 156.7465,
    y2: 110.1559
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st135",
    d: "M161.99,225.88c-2.86-1.43-1.07,7.15-2.5,8.74c-1.42,1.61-8.74-5.35-10.71-4.45 c-0.55,0.25-1.39,1.5-2.42,3.29c0,0,0,0,0,0.01c-0.81,1.39-1.75,3.11-2.75,4.92c-2.36,4.32-5.14,9.23-7.69,11.77 c-4.39,4.4-1.21,10.16-1.94,15.49c-5.03,0-9.68-0.77-13.98-2.09c0.74-3.56-3.86-11.74-6.04-15.91c-2.32-4.45-8.03-6.24-12.85-6.57 c-4.83-0.33-5-6.28-3.04-8.95c1.97-2.68,7.33,1.95,16.69,3.2c9.36,1.25,3.13-22.85,0.63-37.49c-2.5-14.64,3.22-23.22,3.22-23.22 c3.38-3.95,15.34-6.59,19.81-5.69c4.47,0.89,1.79,3.38,0.18,6.42c-1.61,3.04-6.96,10.35-8.03,16.25 c-1.07,5.88,8.39,12.85,11.07,9.99c2.68-2.86,8.74,3.04,7.14,8.74c-1.61,5.72,13.57,7.15,16.97,11.07 C169.14,225.35,164.85,227.31,161.99,225.88z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_128_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.8278,
    y1: 241.4078,
    x2: 176.2024,
    y2: 114.1894
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M144.83,170.76c-2.65,4.71-3.04,10.45-0.75,15.34c0.65,1.39,1.49,2.68,2.55,3.64 c4.26,3.83,9.66,13.63,8.52,17.75c-1.14,4.12,5.54,6.53,7.67,2.41c2.13-4.12,2.65-9.52,4.17-10.08s-1.75-7.24,0.8-11.22 c2.56-3.98,0.58-19.32,15.29-31.4c3.29-2.71,10.56-15.33,5.45-13.2c-5.11,2.13-18.62,3.08-22.45,6.58s-4.68,12.31-10.79,10.61 C151.64,160.17,147.54,165.94,144.83,170.76z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_129_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.2727,
    y1: 253.3171,
    x2: 233.6472,
    y2: 126.0987
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M248.99,76.44c-0.3,4.36-3.16,14.52-6.61,10.79c-2.47-2.68-3.79-7.08-3.73-10.45 c0.67-1.13,1.4-2.34,2.17-3.62c1.39-2.28,2.98-4.76,4.99-7.34C245.4,68.99,249.25,72.51,248.99,76.44z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_130_",
    gradientUnits: "userSpaceOnUse",
    x1: 227.9467,
    y1: 257.6032,
    x2: 254.3212,
    y2: 130.3848
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M272.55,65.73c-2.41,3.81-7.2,14.49,3.15,15.54c10.37,1.03-2.5,10.19-1.86,13.35 c0.66,3.15,1.48,4.8,2.65,5.25c1.15,0.45-8.15,3.9-7.18-1.65c0.98-5.55-2.97-8.11-5.28-4.96c-2.3,3.16-12.06,11.86-9.95,5.57 c2.1-6.31,6.9-13.12,3.3-11.59c-3.6,1.53-9.75-0.25-3.6-5.97c6.16-5.72,12.91-15.63,11.86-18.63c-1.06-3.01-5.71,4.8-7.2,8.25 c-1.51,3.45-7.22,10.49-5.86,3.52c1.35-6.97-3.31-5.47,0.44-10.57c2.74-3.71,6.56-8.18,7.3-11.48c2.58-1.73,5.47-3.42,8.74-5.05 c0.47-0.23,0.93-0.47,1.42-0.7c1.51-0.74,3.12-1.46,4.78-2.14c0.7-0.29,1.4-0.58,2.13-0.85c0.71-0.29,1.46-0.56,2.2-0.84 c0.74-0.29,1.51-0.56,2.3-0.82c0.78-0.27,1.58-0.54,2.39-0.8c0.96,1.91,2.35,3.46-0.63,6.32c0,0-4.95,9.49-7.51,8.26 C273.61,54.53,274.96,61.94,272.55,65.73z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_131_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.3504,
    y1: 280.0771,
    x2: 362.725,
    y2: 152.8587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st139",
    d: "M356.03,208.42c-2.41,3.81-7.2,14.49,3.15,15.54c10.37,1.03-2.5,10.19-1.86,13.35 c0.66,3.15,1.48,4.8,2.65,5.25c1.15,0.45-8.15,3.9-7.18-1.65c0.98-5.55-2.97-8.11-5.28-4.96c-2.3,3.16-12.06,11.86-9.95,5.57 c2.1-6.31,6.9-13.12,3.3-11.59c-3.6,1.53-9.75-0.25-3.6-5.97c6.16-5.72,12.91-15.63,11.86-18.63c-1.06-3.01-5.71,4.8-7.2,8.25 c-1.51,3.45-7.22,10.49-5.86,3.52c1.35-6.97-3.31-5.47,0.44-10.57c1.95-2.65,4.46-5.69,6.01-8.41c1.49-2.63,3.76-4.72,6.4-6.2 c1.58-0.89,3.27-1.76,5.05-2.62c1.51-0.74,3.12-1.46,4.78-2.14c1.7-0.71,3.48-1.4,5.35-2.07c3.05-1.09,5.46,2.74,3.13,4.99 l-0.09,0.09c0,0-4.95,9.49-7.51,8.26C357.09,197.21,358.44,204.62,356.03,208.42z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_132_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.8251,
    y1: 259.8585,
    x2: 265.1996,
    y2: 132.6401
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M282.88,58.69c0.08-1.45-1.51-2.38-2.73-1.59c-1.22,0.79-2.47,1.86-2.43,2.88 c0.08,1.98,0.24,6.35-0.87,6.82c-1.11,0.48,4.44,0.71,5.55-4.76C282.69,60.64,282.83,59.54,282.88,58.69z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_133_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.3924,
    y1: 253.9639,
    x2: 236.767,
    y2: 126.7455
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M214.89,204.09c0.51-1.3,1.47-2.41,2.75-2.96c1.17-0.51,2.47-0.51,3.01,1.52 c1.07,4.04,1.69,10.33,2.91,10.33s1.23,7.2,0,12.11s-3.07,3.76-5.82-2.95s-7.36-7.45-5.21-12.37 C213.68,207.11,214.44,205.25,214.89,204.09z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_134_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.0339,
    y1: 250.5725,
    x2: 220.4085,
    y2: 123.3541
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M248.22,97.93c0,2.17-0.88,4.37-4.43,4.45c-7.11,0.15-7.26,1.39-8.96,3.24c-1.69,1.84-7.56-7.11-10.49-3.4 c-2.93,3.7-5.87,4.62-5.55,7.86c0.3,3.24,0.15,6.68-0.77,8.43c-0.93,1.76,0,4.54,0,10.1c0,5.55-3.86,9.72-3.71,13.73 c0.15,4.01-7.86,8.84-8.95,4.73c-1.09-4.11-6.94-7.97-8.03-6.28c-1.07,1.7-4.63,2.79-2.31-3.4c2.31-6.17,7.25-6.63,5.4-14.34 c-0.58-2.42-0.56-5.2-0.11-7.85c0,0,0-0.01,0.01-0.01c1.33-2.05,2.76-4.43,4.32-6.96c0.92-1.51,1.9-3.07,2.93-4.63 c3.18-4.85,6.82-9.75,11.04-13.32c1.43-1.18,2.91-2.24,4.48-3.08c0.45-0.25,0.91-0.48,1.37-0.69c0.06-0.01,0.1-0.04,0.14-0.05 c0.26-0.12,0.52-0.23,0.78-0.33l0.78-0.29c0.26-0.08,0.51-0.16,0.76-0.23c0.16-0.05,0.33-0.1,0.48-0.14 c0.21-0.06,0.43-0.11,0.65-0.15c0.25-0.05,0.49-0.11,0.74-0.15c-2.13,3.52-4.67,6.27,2.8,6.19c7.82-0.08,8.85-2.12,12.85,0.21 C246.7,92.88,248.22,95.3,248.22,97.93z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_135_",
    gradientUnits: "userSpaceOnUse",
    x1: 316.0998,
    y1: 275.8788,
    x2: 342.4743,
    y2: 148.6604
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M360.34,178.05c0,1.48-0.88,2.98-4.43,3.04c-7.11,0.1-7.26,0.95-8.96,2.21c-1.69,1.26-7.56-4.84-10.49-2.31 c-2.93,2.52-5.87,3.15-5.55,5.36c0.3,2.21,0.15,4.55-0.77,5.74c-0.93,1.2,0,3.09,0,6.89c0,3.79-3.86,6.62-3.71,9.36 c0.15,2.74-7.86,6.02-8.95,3.22c-1.09-2.8-6.94-5.43-8.03-4.28c-1.07,1.16-4.63,1.9-2.31-2.31c2.31-4.21,7.25-4.52,5.4-9.77 c-0.58-1.65-0.56-3.54-0.11-5.35c3.97-12.51,21.21-18.51,22.78-19.08c1.8-0.67,3.7-1.15,5.71-1.39c-2.13,2.4-4.67,4.27,2.8,4.22 c7.82-0.06,8.85-1.44,12.85,0.14C358.82,174.61,360.34,176.26,360.34,178.05z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_136_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.9235,
    y1: 255.7325,
    x2: 245.298,
    y2: 128.5141
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M220.54,252.28c-0.71-1.59-2.87-1.86-3.92-0.48c-1.03,1.35-1.86,2.97-1.63,4.51 c0.54,3.68,6.81,6.27,7.36,2.45C222.65,256.61,221.43,254.27,220.54,252.28z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_137_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.9736,
    y1: 280.2063,
    x2: 363.3481,
    y2: 152.9879
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M340.39,254.27c-1.2-0.62-4.52,0.12-4.05,3.57c0.48,3.45,6.67,16.19,8.45,10.95 C346.58,263.55,343.76,256.02,340.39,254.27z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_138_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.4365,
    y1: 282.5828,
    x2: 374.8111,
    y2: 155.3644
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    style: {
      stopColor: "#37363B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#716D78",
      stopOpacity: 0
    }
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M353.91,268.54c1.36-2.58-2.51-4.71-4.11-2.27c-1.18,1.8-2.39,4.23-2.13,6.4c0.48,4.05,0.25,7.97-2.31,9.52 c-2.57,1.55,5.77,9.4,6.48,0.48c0.71-8.93-1.55-9.98,0.83-12.43C353.17,269.72,353.59,269.13,353.91,268.54z"
  }))), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M565.56,69.99c-7.88,16.39-22.15,31.83-40.56,37.81c-41.34,13.43-80.61-26.33-91.7-51.54 c-6.08-13.8,8.72-25.76,23.34-33.77c0.67,0.25,1.32,0.48,1.95,0.73c0.67,0.25,1.33,0.51,1.99,0.76c0.65,0.25,1.29,0.51,1.92,0.76 c1.53,0.62,2.98,1.21,4.4,1.79c5.11,2.14,9.42,4.15,12.88,5.88c0.38,0.18,0.78,0.38,1.13,0.58c1.86,0.92,3.44,1.77,4.78,2.52 c0.76,0.43,1.46,0.81,2.06,1.17c0.69,0.4,1.26,0.74,1.75,1.04c0.29,0.18,0.54,0.32,0.74,0.45c0.14,0.08,0.23,0.16,0.34,0.22 c0.19,0.12,0.34,0.22,0.45,0.3c0.12,0.07,0.21,0.12,0.23,0.15c0.01,0.01,0.03,0.01,0.03,0.01l0.01,0.03 C514.42,46.26,538.4,56.93,565.56,69.99z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishResult4);
export default __webpack_public_path__ + "static/media/fish-result-4.a59add5124fcfb6f014d00a19005cdd4.svg";
export { ForwardRef as ReactComponent };